import React, { useState, useEffect } from 'react';
import {
  Container,
  Card,
  Form,
  Button,
  Alert,
  Row,
  Col,
  Tabs,
  Tab,
  Table,
  InputGroup
} from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import Navbar from '../../Shared/Navbar/Navbar';
import { baseurl } from '../../Api/Baseurl';
import { Pencil, Trash } from 'react-bootstrap-icons';

// Group tour has no default text for Departure Description.
// Paste your default departure description here if you want it prefilled.
const DEFAULT_DEPARTURE_REMARKS = "";

const AddSeniorTour = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const isEditMode = !!id;


  const [activeTab, setActiveTab] = useState('basic');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  // Dropdowns
  const [categories, setCategories] = useState([]);
  const [destinations, setDestinations] = useState([]);

  // Add state for tourist visa remarks (free flow field)
  const [touristVisaRemarks, setTouristVisaRemarks] = useState('');

  // BASIC DETAILS
  const [formData, setFormData] = useState({
    tour_code: '',
    tour_type: "seniorcitizen",
    title: '',
    category_id: 1,
    primary_destination_id: '',
      country_id: '', // Add this line
    duration_days: '',
    overview: '',
    base_price_adult: '',
     emi_price: '', // ← Add this line
    is_international: 1,
    cost_remarks: "",
    hotel_remarks: "",
    transport_remarks: "",
    booking_poi_remarks: "",
    cancellation_remarks: "",
    emi_remarks: "",
    optional_tour_remarks: "", // ← ADD THIS LINE
    departure_remarks: "",      // NEW - same as Group tour
    instruction_remarks: ""     // NEW - same as Group tour
  });

  // Add this function to get file URL
  const getFileUrl = (fileName) => {
    if (!fileName || typeof fileName !== 'string') {
      return null;
    }
    
    if (fileName.startsWith('http')) {
      return fileName;
    }
    
    if (fileName.startsWith('/uploads/')) {
      return `${baseurl}${fileName}`;
    }
    
    return `${baseurl}/uploads/visa/${fileName}`;
  };
  
  // Function to open file in new tab
  const openFileInNewTab = (url) => {
    if (url) {
      window.open(url, '_blank');
    }
  };
  

       // Reset editing context - ADD THIS FUNCTION
// Reset editing context
const resetEditing = () => {
  setEditingItem(null);
  setEditingType('');
  setEditIndex(-1);
  setEditingVisaItemId(null);
  setEditingVisaFormIndex(null);
  
  // Reset all editing indices
  setEditingItineraryIndex(-1);
  setEditingDepartureIndex(-1);
  setEditingOptionalTourIndex(-1);
  setEditingInclusionIndex(-1);
  setEditingExclusionIndex(-1);
  setEditingTransportIndex(-1);
  setEditingBookingPoiIndex(-1);
  setEditingCancellationIndex(-1);
  setEditingInstructionIndex(-1);
  setEditingHotelIndex(-1);
  
  // Also reset any form fields that might be in edit mode
  if (editingType === 'touristVisa') {
    setTouristVisaForm({ description: '' });
  } else if (editingType === 'transitVisa') {
    setTransitVisaForm({ description: '' });
  } else if (editingType === 'businessVisa') {
    setBusinessVisaForm({ description: '' });
  } else if (editingType === 'photo') {
    setPhotoForm({ description: '' });
  } else if (editingType === 'freeFlowPhoto') {
    setFreeFlowPhotoText('');
  }
  
  // Reset visa form edit data
  if (editingVisaFormIndex !== null) {
    setVisaFormEditData({
      type: '',
      download_text: '',
      download_action: '',
      fill_action: '',
      action1_file: null,
      action2_file: null
    });
    setEditingVisaFormIndex(null);
  }
};


const visaSubTabs = ['tourist', 'transit', 'business', 'form', 'photo', 'fees', 'submission'];

const TAB_LIST = [
  'basic',
  'itineraries',
  'departures',
  'optionalTours',
  'emiOptions',
  'inclusions',
  'exclusions',
  'transport',
  'hotels',
  ...(formData.is_international === 1 ? ['visa'] : []), // Main visa tab
  'bookingPoi',
  'cancellation',
  'instructions',
  'images'
];

  // =======================
  // DEPARTURES FOR SENIOR CITIZEN TOURS - UPDATED WITH HOTEL PRICE FIELDS
  // =======================
  const [seniorDepartureForm, setSeniorDepartureForm] = useState({
    start_date: '',
    end_date: '',
    status: 'Available',
    total_seats: 40,
    booked_seats: 0,
    description: '',
    // 3-Star Hotel Prices
    three_star_twin: '',
    three_star_triple: '',
    three_star_child_with_bed: '',
    three_star_child_without_bed: '',
    three_star_infant: '',
    three_star_single: '',
    // 4-Star Hotel Prices
    four_star_twin: '',
    four_star_triple: '',
    four_star_child_with_bed: '',
    four_star_child_without_bed: '',
    four_star_infant: '',
    four_star_single: '',
    // 5-Star Hotel Prices
    five_star_twin: '',
    five_star_triple: '',
    five_star_child_with_bed: '',
    five_star_child_without_bed: '',
    five_star_infant: '',
    five_star_single: ''
  });

  const [departures, setDepartures] = useState([]);

  // EXCLUSIONS
  const [exclusionText, setExclusionText] = useState('');
  const [exclusions, setExclusions] = useState([]);

  // INCLUSIONS
  const [inclusionText, setInclusionText] = useState('');
  const [inclusions, setInclusions] = useState([]);

  // IMAGES
  const [imageFiles, setImageFiles] = useState([]);
  const [imagePreviews, setImagePreviews] = useState([]);
  const [imageCaption, setImageCaption] = useState('');

  // Add these for image management:
  const [existingImages, setExistingImages] = useState([]);
  const [editingImageId, setEditingImageId] = useState(null);
  const [replacementFile, setReplacementFile] = useState(null);
  const [replacementPreview, setReplacementPreview] = useState(null);


  const [editingItem, setEditingItem] = useState(null);
    const [editingType, setEditingType] = useState('');
    const [editIndex, setEditIndex] = useState(-1);


    // Add these state variables near your other state declarations
const [editingItineraryIndex, setEditingItineraryIndex] = useState(-1);
const [editingDepartureIndex, setEditingDepartureIndex] = useState(-1);
const [editingOptionalTourIndex, setEditingOptionalTourIndex] = useState(-1);
const [editingInclusionIndex, setEditingInclusionIndex] = useState(-1);
const [editingExclusionIndex, setEditingExclusionIndex] = useState(-1);
const [editingTransportIndex, setEditingTransportIndex] = useState(-1);
const [editingBookingPoiIndex, setEditingBookingPoiIndex] = useState(-1);
const [editingCancellationIndex, setEditingCancellationIndex] = useState(-1);
const [editingInstructionIndex, setEditingInstructionIndex] = useState(-1);
const [editingHotelIndex, setEditingHotelIndex] = useState(-1); // Add for hotels



const [freeFlowPhotoEntries, setFreeFlowPhotoEntries] = useState([]);
  const [freeFlowPhotoText, setFreeFlowPhotoText] = useState('');
  
  
  // Add these functions near your other handler functions
  
  // Add Free Flow Photo Entry
  const addFreeFlowPhotoEntry = () => {
    const trimmed = freeFlowPhotoText.trim();
    if (!trimmed) return;
    
    setFreeFlowPhotoEntries(prev => [...prev, { description: trimmed }]);
    setFreeFlowPhotoText('');
  };
  
  // Edit Free Flow Photo Entry
  const editFreeFlowPhotoEntry = (idx) => {
    const item = freeFlowPhotoEntries[idx];
    setFreeFlowPhotoText(item.description);
    setEditingItem(item);
    setEditingType('freeFlowPhoto');
    setEditIndex(idx);
  };
  
  // Remove Free Flow Photo Entry
  const removeFreeFlowPhotoEntry = (idx) => {
    setFreeFlowPhotoEntries(prev => prev.filter((_, i) => i !== idx));
  };
  
  // Handle Free Flow Photo Text Change
  const handleFreeFlowPhotoChange = (e) => {
    setFreeFlowPhotoText(e.target.value);
  };


  
  
const [extendableRow, setExtendableRow] = useState({
  type: 'Extendable as per requirement',
  tourist: '',
  transit: '',
  business: '',
  tourist_charges: '',
  transit_charges: '',
  business_charges: ''
});



 const handleGroupDepartureChange = (e) => {
    const { name, value } = e.target;
    const numericFields = [
      'total_seats', 'booked_seats',
      'three_star_twin', 'three_star_triple', 'three_star_child_with_bed',
      'three_star_child_without_bed', 'three_star_infant', 'three_star_single',
      'four_star_twin', 'four_star_triple', 'four_star_child_with_bed',
      'four_star_child_without_bed', 'four_star_infant', 'four_star_single',
      'five_star_twin', 'five_star_triple', 'five_star_child_with_bed',
      'five_star_child_without_bed', 'five_star_infant', 'five_star_single'
    ];

    setSeniorDepartureForm((prev) => ({
      ...prev,
      [name]: numericFields.includes(name)
        ? value === '' ? '' : Number(value)
        : value
    }));
  };


  // =======================
  // OPTIONAL TOURS
  // =======================
  const [optionalTourItem, setOptionalTourItem] = useState({
    tour_name: '',
    adult_price: '',
    child_price: ''
  });
  const [optionalTours, setOptionalTours] = useState([]);

  const handleOptionalTourChange = (e) => {
    const { name, value } = e.target;
    setOptionalTourItem(prev => ({ ...prev, [name]: value }));
  };

  const addOptionalTourRow = () => {
  if (!optionalTourItem.tour_name.trim()) return;

  const processedItem = {
    ...optionalTourItem
  };

  if (editingOptionalTourIndex !== -1) {
    // Update existing
    const updated = [...optionalTours];
    updated[editingOptionalTourIndex] = processedItem;
    setOptionalTours(updated);
    setEditingOptionalTourIndex(-1);
  } else {
    // Add new
    setOptionalTours(prev => [...prev, processedItem]);
  }

  setOptionalTourItem({
    tour_name: '',
    adult_price: '',
    child_price: ''
  });
};

const editOptionalTourRow = (idx) => {
  const item = optionalTours[idx];
  setOptionalTourItem(item);
  setEditingOptionalTourIndex(idx);
};

const removeOptionalTourRow = (idx) => {
  const confirmDelete = window.confirm('Are you sure you want to remove this optional tour?');
  if (confirmDelete) {
    setOptionalTours(prev => prev.filter((_, i) => i !== idx));
    if (editingOptionalTourIndex === idx) {
      setEditingOptionalTourIndex(-1);
      setOptionalTourItem({
        tour_name: '',
        adult_price: '',
        child_price: ''
      });
    }
  }
};

  // =======================
  // EMI OPTIONS
  // =======================
  const [emiOptions, setEmiOptions] = useState([
    { particulars: 'Per Month Payment', loan_amount: '', months: 6, emi: '' },
    { particulars: 'Per Month Payment', loan_amount: '', months: 12, emi: '' },
    { particulars: 'Per Month Payment', loan_amount: '', months: 18, emi: '' },
    { particulars: 'Per Month Payment', loan_amount: '', months: 24, emi: '' },
    { particulars: 'Per Month Payment', loan_amount: '', months: 30, emi: '' },
    { particulars: 'Per Month Payment', loan_amount: '', months: 36, emi: '' },
    { particulars: 'Per Month Payment', loan_amount: '', months: 48, emi: '' }
  ]);

 // Add this state for EMI
const [emiLoanAmount, setEmiLoanAmount] = useState('');
const [emiInterestRate, setEmiInterestRate] = useState(18);

// Add this function to calculate EMI
const calculateEMI = (loanAmount, months, interestRate = 18) => {
  const principal = parseFloat(loanAmount);
  const monthlyRate = (interestRate / 100) / 12;
  const n = parseInt(months, 10);
  
  if (isNaN(principal) || principal <= 0 || isNaN(n) || n <= 0) return 0;
  
  const emi = principal * monthlyRate * Math.pow(1 + monthlyRate, n) / 
              (Math.pow(1 + monthlyRate, n) - 1);
  
  return Math.round(emi * 100) / 100;
};

// Add this effect to update EMI values when loan amount changes
useEffect(() => {
  if (emiLoanAmount && !isNaN(emiLoanAmount) && emiLoanAmount > 0) {
    const updatedOptions = emiOptions.map(option => ({
      ...option,
      loan_amount: emiLoanAmount,
      emi: calculateEMI(emiLoanAmount, option.months, emiInterestRate)
    }));
    setEmiOptions(updatedOptions);
  }
}, [emiLoanAmount, emiInterestRate]);

// Update the handleLoanAmountChange function
const handleLoanAmountChange = (value) => {
  setEmiLoanAmount(value);
  
  if (value && !isNaN(value) && value > 0) {
    const updatedOptions = emiOptions.map(option => ({
      ...option,
      loan_amount: value,
      emi: calculateEMI(value, option.months, emiInterestRate)
    }));
    setEmiOptions(updatedOptions);
  }
};

  // =======================
  // HOTELS
  // =======================



  const [hotelItem, setHotelItem] = useState({
       city: '',
       nights: '',
       standard_hotel_name: '', 
       deluxe_hotel_name: '',   
       executive_hotel_name: '',
       remarks: ''
     });
     const [hotelRows, setHotelRows] = useState([]);
 
    const handleHotelChange = (e) => {
     const { name, value } = e.target;
     setHotelItem(prev => ({ ...prev, [name]: value }));
   };
 
   const addHotelRow = () => {
   if (!hotelItem.city.trim() || 
       (!hotelItem.standard_hotel_name.trim() && 
        !hotelItem.deluxe_hotel_name.trim() && 
        !hotelItem.executive_hotel_name.trim())) {
     setError('Please enter city and at least one hotel name');
     return;
   }
   
   if (editingHotelIndex !== -1) {
     // FIXED: Update existing item using the index set by editHotelRow
     const updated = [...hotelRows];
     updated[editingHotelIndex] = { ...hotelItem };
     setHotelRows(updated);
   } else if (editingType === 'hotel' && editIndex !== -1) {
     // Update existing item
     const updated = [...hotelRows];
     updated[editIndex] = { ...hotelItem };
     setHotelRows(updated);
   } else {
     // Add new item
     setHotelRows(prev => [...prev, { ...hotelItem }]);
   }
   
   // Reset form
   setHotelItem({
     city: '',
     nights: '',
     standard_hotel_name: '', 
     deluxe_hotel_name: '',   
     executive_hotel_name: '',
     remarks: ''
   });
   
   // Reset editing context
   resetEditing();
 };
 
   // Edit hotel row - FIXED
   const editHotelRow = (idx) => {
  const item = hotelRows[idx];
  setHotelItem(item);
  setEditingHotelIndex(idx);
};

const removeHotelRow = (idx) => {
  const confirmDelete = window.confirm('Are you sure you want to remove this hotel?');
  if (confirmDelete) {
    setHotelRows(prev => prev.filter((_, i) => i !== idx));
    if (editingHotelIndex === idx) {
      setEditingHotelIndex(-1);
      setHotelItem({
        city: '',
        nights: '',
        standard_hotel_name: '', 
        deluxe_hotel_name: '',   
        executive_hotel_name: '',
        remarks: ''
      });
    }
  }
};




  // ========================
// VISA STATE FOR LADIES SPECIAL TOURS
// ========================
const [activeVisaSubTab, setActiveVisaSubTab] = useState('tourist');

// Tourist Visa
const [touristVisaItems, setTouristVisaItems] = useState([]);
const [touristVisaForm, setTouristVisaForm] = useState({ description: '' });

// Transit Visa
const [transitVisaItems, setTransitVisaItems] = useState([]);
const [transitVisaForm, setTransitVisaForm] = useState({ description: '' });

// Business Visa
const [businessVisaItems, setBusinessVisaItems] = useState([]);
const [businessVisaForm, setBusinessVisaForm] = useState({ description: '' });

// Visa Form
const [visaFormItems, setVisaFormItems] = useState([]);

// Photo
const [photoItems, setPhotoItems] = useState([]);
const [photoForm, setPhotoForm] = useState({ description: '' });

// Visa Fees
const [visaFeesRows, setVisaFeesRows] = useState([
  { 
    id: 1,
    type: 'Visa Fee', 
    tourist: '', 
    transit: '', 
    business: '', 
    tourist_charges: '', // Separate for Tourist
    transit_charges: '', // Separate for Transit
    business_charges: '' // Separate for Business
  },
  { 
    id: 2,
    type: 'VFS Fee', 
    tourist: '', 
    transit: '', 
    business: '', 
    tourist_charges: '',
    transit_charges: '',
    business_charges: ''
  },
  { 
    id: 3,
    type: 'Other Charges', 
    tourist: '', 
    transit: '', 
    business: '', 
    tourist_charges: '',
    transit_charges: '',
    business_charges: ''
  }
]);

// Add these state variables for visa form editing
const [editingVisaFormIndex, setEditingVisaFormIndex] = useState(null);
const [visaFormEditData, setVisaFormEditData] = useState({
  type: '',
  download_text: '',
  download_action: '',
  fill_action: '',
  action1_file: null,
  action2_file: null
});

// Add this state for editing context
const [editingVisaItemId, setEditingVisaItemId] = useState(null);




// Function to add new free flow entry
const addVisaFeesRow = () => {
  const newId = visaFeesRows.length > 0 
    ? Math.max(...visaFeesRows.map(row => row.id)) + 1 
    : 1;
  
  setVisaFeesRows([
    ...visaFeesRows,
    { 
      id: newId,
      type: 'Free Flow Entry', 
      tourist: '', 
      transit: '', 
      business: '', 
      tourist_charges: '',
      transit_charges: '',
      business_charges: ''
    }
  ]);
};


// Submission & Pick Up
const [submissionRows, setSubmissionRows] = useState([
  { 
    id: 1,
    label: 'Passport Submission Day', 
    tourist: '', 
    transit: '', 
    business: '' 
  },
  { 
    id: 2,
    label: 'Passport Submission Time', 
    tourist: '', 
    transit: '', 
    business: '' 
  },
  { 
    id: 3,
    label: 'Passport pick up Days', 
    tourist: '', 
    transit: '', 
    business: '' 
  },
  { 
    id: 4,
    label: 'Passport Pick Up Time', 
    tourist: '', 
    transit: '', 
    business: '' 
  },
  { 
    id: 5,
    label: 'Biometric requirement', 
    tourist: '', 
    transit: '', 
    business: '' 
  }
]);

// Function to add new free flow entry in Submission & Pick Up
const addSubmissionRow = () => {
  const newId = submissionRows.length > 0 
    ? Math.max(...submissionRows.map(row => row.id)) + 1 
    : 1;
  
  setSubmissionRows([
    ...submissionRows,
    { 
      id: newId,
      label: 'Free Flow Entry', 
      tourist: '', 
      transit: '', 
      business: '' 
    }
  ]);
};




// Function to handle label change in Submission & Pick Up
const handleSubmissionLabelChange = (id, value) => {
  const updated = submissionRows.map(row => 
    row.id === id ? { ...row, label: value } : row
  );
  setSubmissionRows(updated);
};

// Function to handle value change in Submission & Pick Up
const handleSubmissionValueChange = (id, field, value) => {
  const updated = submissionRows.map(row => 
    row.id === id ? { ...row, [field]: value } : row
  );
  setSubmissionRows(updated);
};


// Edit Tourist Visa - FIXED
const editTouristVisa = (idx) => {
  const item = touristVisaItems[idx];
  setTouristVisaForm({ description: item.description });
  setEditingItem(item);
  setEditingType('touristVisa');
  setEditIndex(idx);
};

// Edit Transit Visa - FIXED
const editTransitVisa = (idx) => {
  const item = transitVisaItems[idx];
  setTransitVisaForm({ description: item.description });
  setEditingItem(item);
  setEditingType('transitVisa');
  setEditIndex(idx);
};

// Edit Business Visa - FIXED
const editBusinessVisa = (idx) => {
  const item = businessVisaItems[idx];
  setBusinessVisaForm({ description: item.description });
  setEditingItem(item);
  setEditingType('businessVisa');
  setEditIndex(idx);
};

// Edit Photo - FIXED
const editPhoto = (idx) => {
  const item = photoItems[idx];
  setPhotoForm({ description: item.description });
  setEditingItem(item);
  setEditingType('photo');
  setEditIndex(idx);
};


// Edit Visa Form Item
const editVisaFormItem = (index) => {
  const formItem = visaFormItems[index];
  setVisaFormEditData({
    type: formItem.type,
    download_text: formItem.download_text,
    download_action: formItem.download_action,
    fill_action: formItem.fill_action,
    action1_file: formItem.action1_file,
    action2_file: formItem.action2_file
  });
  setEditingVisaFormIndex(index);
  setActiveVisaSubTab('form');
};

// Update Visa Form Item
const updateVisaFormItem = () => {
  if (editingVisaFormIndex === null) return;
  
  const updated = [...visaFormItems];
  updated[editingVisaFormIndex] = {
    ...updated[editingVisaFormIndex],
    ...visaFormEditData
  };
  
  setVisaFormItems(updated);
  resetVisaFormEdit();
};

// Reset Visa Form Edit
const resetVisaFormEdit = () => {
  setEditingVisaFormIndex(null);
  setVisaFormEditData({
    type: '',
    download_text: '',
    download_action: '',
    fill_action: '',
    action1_file: null,
    action2_file: null
  });
};

// Handle Visa Form Edit Change
const handleVisaFormEditChange = (e) => {
  const { name, value } = e.target;
  setVisaFormEditData(prev => ({
    ...prev,
    [name]: value
  }));
};

// Handle Visa Form File Change with Edit Support
const handleVisaFormFileChangeWithEdit = async (index, action, file) => {
  if (!file) return;
  
  if (editingVisaFormIndex !== null && editingVisaFormIndex === index) {
    // If editing, update the edit data - store as File object
    setVisaFormEditData(prev => ({
      ...prev,
      [action === 'action1' ? 'action1_file' : 'action2_file']: file
    }));
  } else {
    // If not editing, update the main list
    const updated = [...visaFormItems];
    updated[index][action === 'action1' ? 'action1_file' : 'action2_file'] = file;
    setVisaFormItems(updated);
  }
  
  // Upload file if in edit mode
  if (isEditMode && id) {
    const visaType = editingVisaFormIndex !== null 
      ? visaFormEditData.type 
      : visaFormItems[index].type;
    
    const uploadedFileName = await handleVisaFormFileUpload(id, visaType, action, file);
    if (uploadedFileName) {
      if (editingVisaFormIndex !== null && editingVisaFormIndex === index) {
        // Update edit data with filename string
        setVisaFormEditData(prev => ({
          ...prev,
          [action === 'action1' ? 'action1_file' : 'action2_file']: uploadedFileName
        }));
      } else {
        // Update main list with filename string
        const updatedWithFilename = [...visaFormItems];
        updatedWithFilename[index][action === 'action1' ? 'action1_file' : 'action2_file'] = uploadedFileName;
        setVisaFormItems(updatedWithFilename);
      }
    }
  }
};


// Add Tourist Visa - FIXED
const addTouristVisa = () => {
  const trimmed = touristVisaForm.description.trim();
  if (!trimmed) return;
  
  const newItem = { description: trimmed };
  
  if (editingType === 'touristVisa' && editIndex !== -1) {
    const updated = [...touristVisaItems];
    updated[editIndex] = newItem;
    setTouristVisaItems(updated);
  } else {
    setTouristVisaItems(prev => [...prev, newItem]);
  }
  
  setTouristVisaForm({ description: '' });
  resetEditing();
};

// Add Transit Visa - FIXED
const addTransitVisa = () => {
  const trimmed = transitVisaForm.description.trim();
  if (!trimmed) return;
  
  const newItem = { description: trimmed };
  
  if (editingType === 'transitVisa' && editIndex !== -1) {
    const updated = [...transitVisaItems];
    updated[editIndex] = newItem;
    setTransitVisaItems(updated);
  } else {
    setTransitVisaItems(prev => [...prev, newItem]);
  }
  
  setTransitVisaForm({ description: '' });
  resetEditing();
};

// Add Business Visa - FIXED
const addBusinessVisa = () => {
  const trimmed = businessVisaForm.description.trim();
  if (!trimmed) return;
  
  const newItem = { description: trimmed };
  
  if (editingType === 'businessVisa' && editIndex !== -1) {
    const updated = [...businessVisaItems];
    updated[editIndex] = newItem;
    setBusinessVisaItems(updated);
  } else {
    setBusinessVisaItems(prev => [...prev, newItem]);
  }
  
  setBusinessVisaForm({ description: '' });
  resetEditing();
};

// Add Photo - FIXED
const addPhoto = () => {
  const trimmed = photoForm.description.trim();
  if (!trimmed) return;
  
  const newItem = { description: trimmed };
  
  if (editingType === 'photo' && editIndex !== -1) {
    const updated = [...photoItems];
    updated[editIndex] = newItem;
    setPhotoItems(updated);
  } else {
    setPhotoItems(prev => [...prev, newItem]);
  }
  
  setPhotoForm({ description: '' });
  resetEditing();
};


// Remove Tourist Visa
const removeTouristVisa = (idx) => {
  const confirmDelete = window.confirm('Are you sure you want to remove this tourist visa item?');
  if (confirmDelete) {
    setTouristVisaItems(prev => prev.filter((_, i) => i !== idx));
  }
};

// Remove Transit Visa
const removeTransitVisa = (idx) => {
  const confirmDelete = window.confirm('Are you sure you want to remove this transit visa item?');
  if (confirmDelete) {
    setTransitVisaItems(prev => prev.filter((_, i) => i !== idx));
  }
};

// Remove Business Visa
const removeBusinessVisa = (idx) => {
  const confirmDelete = window.confirm('Are you sure you want to remove this business visa item?');
  if (confirmDelete) {
    setBusinessVisaItems(prev => prev.filter((_, i) => i !== idx));
  }
};

// Remove Photo
const removePhoto = (idx) => {
  const confirmDelete = window.confirm('Are you sure you want to remove this photo item?');
  if (confirmDelete) {
    setPhotoItems(prev => prev.filter((_, i) => i !== idx));
  }
};


// Function to remove a row from Submission & Pick Up
const removeSubmissionRow = (id) => {
  const confirmDelete = window.confirm('Are you sure you want to remove this submission row?');
  if (confirmDelete) {
    setSubmissionRows(submissionRows.filter(row => row.id !== id));
  }
};

// Function to remove a row
const removeVisaFeesRow = (id) => {
  const confirmDelete = window.confirm('Are you sure you want to remove this visa fee row?');
  if (confirmDelete) {
    setVisaFeesRows(visaFeesRows.filter(row => row.id !== id));
  }
};


// Visa Form Change Handlers
const handleTouristVisaChange = (e) => {
  const { name, value } = e.target;
  setTouristVisaForm(prev => ({ ...prev, [name]: value }));
};

const handleTransitVisaChange = (e) => {
  const { name, value } = e.target;
  setTransitVisaForm(prev => ({ ...prev, [name]: value }));
};

const handleBusinessVisaChange = (e) => {
  const { name, value } = e.target;
  setBusinessVisaForm(prev => ({ ...prev, [name]: value }));
};

const handlePhotoChange = (e) => {
  const { name, value } = e.target;
  setPhotoForm(prev => ({ ...prev, [name]: value }));
};

const handleVisaFeesChange = (id, field, value) => {
  const updated = visaFeesRows.map(row => 
    row.id === id ? { ...row, [field]: value } : row
  );
  setVisaFeesRows(updated);
};

const handleSubmissionChange = (index, field, value) => {
  const updated = [...submissionRows];
  updated[index][field] = value;
  setSubmissionRows(updated);
};


// Add this function to handle file uploads for visa forms

const handleVisaFormFileChange = async (index, action, file) => {
  if (!file) return;
  
  const updated = [...visaFormItems];
  if (action === 'action1') {
    updated[index].action1_file = file; // Store file object
  } else {
    updated[index].action2_file = file; // Store file object
  }
  setVisaFormItems(updated);
  
  // If editing mode, upload immediately and get filename
  if (isEditMode && id) {
    const uploadedFileName = await handleVisaFormFileUpload(id, visaFormItems[index].type, action, file);
    if (uploadedFileName) {
      const updatedWithFilename = [...visaFormItems];
      if (action === 'action1') {
        updatedWithFilename[index].action1_file = uploadedFileName; // Store filename
      } else {
        updatedWithFilename[index].action2_file = uploadedFileName; // Store filename
      }
      setVisaFormItems(updatedWithFilename);
    }
  }
};
// Add this function to your frontend component
// Update this function in your frontend code
const handleVisaFormFileUpload = async (tourId, visaType, actionType, file) => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('visa_type', visaType);
    formData.append('action_type', actionType);

    console.log('📤 Uploading visa form file:', {
      tourId,
      visaType,
      actionType,
      fileName: file.name
    });

    const response = await fetch(`${baseurl}/api/visa/upload-file/${tourId}`, {
      method: 'POST',
      body: formData
      // Don't set Content-Type header - let browser set it with boundary
    });

    const result = await response.json();
    
    if (result.success) {
      console.log('✅ File uploaded successfully:', result);
      return result.fileName;
    } else {
      console.error('❌ File upload failed:', result.error);
      return null;
    }
  } catch (err) {
    console.error('❌ Upload error:', err);
    return null;
  }
};


// Handler for tourist visa remarks
const handleTouristVisaRemarksChange = (e) => {
  setTouristVisaRemarks(e.target.value);
};


  // =======================
  // TRANSPORT FOR SENIOR CITIZEN TOURS
  // =======================
  const [transportItem, setTransportItem] = useState({
    description: '',
    airline: '',
    flight_no: '',
    from_city: '',
    from_date: '',
    from_time: '',
    to_city: '',
    to_date: '',
    to_time: '',
    via: '',
    sort_order: 1
  });

  const [transports, setTransports] = useState([]);

  const handleTransportChange = (e) => {
    const { name, value } = e.target;
    setTransportItem(prev => ({ ...prev, [name]: value }));
  };

  const addTransportRow = () => {
    if (!transportItem.airline || !transportItem.flight_no || !transportItem.from_city || !transportItem.to_city) {
      return;
    }

    if (editingTransportIndex !== -1) {
      // Update existing
      const updated = [...transports];
      updated[editingTransportIndex] = { ...transportItem };
      setTransports(updated);
      setEditingTransportIndex(-1);
      setSuccess('Transport updated successfully');
    } else {
      // Add new
      setTransports(prev => [...prev, { ...transportItem, sort_order: prev.length + 1 }]);
      setSuccess('Transport added successfully');
    }

    setTransportItem({
      description: '',
      airline: '',
      flight_no: '',
      from_city: '',
      from_date: '',
      from_time: '',
      to_city: '',
      to_date: '',
      to_time: '',
      via: '',
      sort_order: transports.length + 2
    });
  };

  const editTransportRow = (idx) => {
    const item = transports[idx];
    setTransportItem(item);
    setEditingTransportIndex(idx);
  };

const removeTransportRow = (idx) => {
  const confirmDelete = window.confirm('Are you sure you want to remove this transport?');
  if (confirmDelete) {
    setTransports(prev => prev.filter((_, i) => i !== idx));
    if (editingTransportIndex === idx) {
      setEditingTransportIndex(-1);
      setTransportItem({
        description: '',
        airline: '',
        flight_no: '',
        from_city: '',
        from_date: '',
        from_time: '',
        to_city: '',
        to_date: '',
        to_time: '',
        via: '',
        sort_order: transports.length + 1
      });
    }
  }
};

  // =======================
  // BOOKING POI - FIXED FOR IN-PLACE EDIT
  // =======================
  const [poiText, setPoiText] = useState('');
  const [poiAmount, setPoiAmount] = useState("");
  const [bookingPois, setBookingPois] = useState([]);

  const addPoi = () => {
    const txt = poiText.trim();
    if (!txt) return;
    
    if (editingBookingPoiIndex !== -1) {
      // Update existing
      const updated = [...bookingPois];
      updated[editingBookingPoiIndex] = { item: poiText, amount_details: poiAmount, sort_order: bookingPois[editingBookingPoiIndex].sort_order };
      setBookingPois(updated);
      setEditingBookingPoiIndex(-1);
      setSuccess('Booking policy updated successfully');
    } else {
      // Add new
      setBookingPois([
        ...bookingPois,
        { item: poiText, amount_details: poiAmount, sort_order: bookingPois.length + 1 }
      ]);
      setSuccess('Booking policy added successfully');
    }
    
    setPoiText('');
    setPoiAmount("");
  };

  const editPoi = (idx) => {
    const poi = bookingPois[idx];
    setPoiText(poi.item);
    setPoiAmount(poi.amount_details);
    setEditingBookingPoiIndex(idx);
  };

  const removePoi = (idx) => {
    const confirmDelete = window.confirm('Are you sure you want to remove this booking POI?');
    if (confirmDelete) {
      setBookingPois(prev => prev.filter((_, i) => i !== idx));
      if (editingBookingPoiIndex === idx) {
        setEditingBookingPoiIndex(-1);
        setPoiText('');
        setPoiAmount("");
      }
    }
  };

  // =======================
  // CANCELLATION - FIXED FOR IN-PLACE EDIT
  // =======================
  const [cancelItem, setCancelItem] = useState({
    cancellation_policy: "",
    charges: "",
    sort_order: 1
  });

  const [cancelPolicies, setCancelPolicies] = useState([]);

  const handleCancelChange = (e) => {
    const { name, value } = e.target;
    setCancelItem(prev => ({ ...prev, [name]: value }));
  };

  const addCancelRow = () => {
    if (!cancelItem.cancellation_policy.trim()) return;
    
    const newCancel = { ...cancelItem, sort_order: cancelPolicies.length + 1 };
    
    if (editingCancellationIndex !== -1) {
      // Update existing
      const updated = [...cancelPolicies];
      updated[editingCancellationIndex] = { ...newCancel, sort_order: cancelPolicies[editingCancellationIndex].sort_order };
      setCancelPolicies(updated);
      setEditingCancellationIndex(-1);
      setSuccess('Cancellation policy updated successfully');
    } else {
      // Add new
      setCancelPolicies(prev => [...prev, newCancel]);
      setSuccess('Cancellation policy added successfully');
    }
    
    setCancelItem({ cancellation_policy: "", charges: "", sort_order: cancelPolicies.length + 2 });
  };

  const editCancelRow = (idx) => {
    const policy = cancelPolicies[idx];
    setCancelItem(policy);
    setEditingCancellationIndex(idx);
  };

  const removeCancelRow = (idx) => {
    const confirmDelete = window.confirm('Are you sure you want to remove this cancellation policy?');
    if (confirmDelete) {
      setCancelPolicies(prev => prev.filter((_, i) => i !== idx));
      if (editingCancellationIndex === idx) {
        setEditingCancellationIndex(-1);
        setCancelItem({ cancellation_policy: "", charges: "", sort_order: 1 });
      }
    }
  };



// Add this useEffect to set initial prefilled content for international tours
useEffect(() => {
  // Only set default content if it's a new tour (not edit mode)
  if (!isEditMode) {
    // Prefill all remarks fields including visa remarks
    setFormData(prev => ({
      ...prev,
      departure_remarks: DEFAULT_DEPARTURE_REMARKS,
      cost_remarks: "The tour prices quoted are based on the number of passengers travelling together, so simply select your group size to view the applicable rate displayed alongside it. These prices are provided to give you a realistic estimate of the expected tour cost for the standard itinerary and help you plan your holiday budget with confidence. Please note that if you choose to upgrade to Deluxe or Executive category hotels, the child rates may also vary accordingly. As travel prices are influenced by factors such as hotel availability, airline fares, seasonal demand, and the transition between low and high seasons, the final tour cost may differ depending on your selected travel dates, especially when booking closer to departure. To ensure complete transparency and provide you with the most accurate and up-to-date pricing, we kindly request that you reconfirm the tour cost before making your booking and quote the tour code while enquiring. This allows us to offer you the best available rates and ensure there are no surprises later, helping you plan your journey with complete peace of mind.",
      hotel_remarks: "While we may provide hotel names or options for reference, final availability is always subject to confirmation at the time of booking. If the listed hotels are fully booked or not operational, accommodation will be arranged in hotels of a similar category, offering comparable standards and comfort; however, specific hotel selection cannot be guaranteed. Should a guest prefer accommodation at a hotel outside our regular offerings, this can be arranged at an additional cost, subject to availability",
      transport_remarks: "The flight details displayed in the itinerary, brochure, quotation, website, or promotional material are tentative and are provided for reference purposes only. Flight schedules, airlines, routing, and timings may be revised depending upon operational requirements, airline availability, and the final group size confirmed for the departure.To ensure seat availability for group departures, flight seats are blocked with airlines in advance. As these are PAN India group departures, flight arrangements are coordinated with the respective airlines and tickets are generally issued closer to the departure date. Complete flight details, including airline name, flight number, departure and arrival timings, and baggage allowance, will be shared with guests once the air tickets are issued.The Client expressly acknowledges and agrees that flight fares are dynamic in nature and are subject to change at any time without prior notice by the airline. The tour cost is therefore based on the airfare prevailing at the time of booking and seat confirmation.Once air tickets are issued, the tickets shall be treated as strictly non-cancellable, non-transferable, non-changeable, and non-refundable, as group air tickets are issued under special airline fare categories and conditions. No refund, credit note, or adjustment shall be provided under any circumstances after ticket issuance.In the event that a guest wishes to prepone or postpone the travel dates after confirmation of the tour and issuance of air tickets, the original tickets shall remain non-refundable and non-transferable. Any revised travel arrangement shall require the purchase of fresh air tickets at the prevailing airfare applicable on the date of amendment, and the entire additional cost shall be borne by the guest.The Client further acknowledges that if the initially blocked flight inventory for a particular departure is fully utilized, any additional passengers seeking to join the same departure shall be booked on flights at the prevailing airfare available at the time of booking. Any increase in airfare, taxes, airline surcharges, or related charges shall be payable by the guest before confirmation of the booking.Flights included in the tour package may be either direct flights or flights operating with one or more transit stops, depending upon airline schedules, availability, operational considerations, and destination requirements. The Company reserves the right to select and modify the airline, routing, and flight schedule as may be necessary.Guests intending to make their own travel arrangements to the departure city, including travel by train, bus, private vehicle, or any other mode of transport, are required to obtain prior confirmation from the Company before making such bookings. This is necessary to ensure proper coordination with the group departure schedule and to avoid any inconvenience arising from schedule changes.For all group departures, the Company makes every reasonable effort to operate the tour with the required minimum number of participants. However, in the event that the minimum group size is not achieved by the scheduled departure date, or due to operational, logistical, airline-related, governmental, force majeure, or other unavoidable circumstances, the Company reserves the absolute right to merge two or more departures, revise the departure date, or make suitable operational adjustments in the interest of smooth tour execution.In the event of such a merger or revised departure schedule, guests shall be informed accordingly. If a guest does not wish to travel on the revised departure date and insists on travelling on the originally scheduled departure date, the Company may, at its sole discretion and subject to operational feasibility, operate the tour with the available number of confirmed passengers. Any additional costs arising due to such arrangements, including but not limited to airfare differences, transportation, accommodation, or operational expenses, shall be borne by the guest.By confirming the booking and making payment towards the tour, the Client acknowledges that he/she has read, understood, and accepted the above Flight Booking, Fare & Group Departure Policy and agrees to abide by the same without dispute or claim",
      booking_poi_remarks: "The tour price indicated above is applicable for group of passengers traveling together. Any change in the number of travellers shall be deemed a modification of the booking and may result in a revision of the tour price. Clients are advised to contact the company at the time of booking to confirm the final and accurate cost. While the company endeavours to publish rates for groups of up to ten adults, such rates are indicative and may vary on a case-by-case basis; if the published rates do not meet the client’s requirements, the client is requested to communicate directly via email at salil@sktt.in. The company accepts all standard modes of payment; however, payments made via credit card may be subject to additional charges as per the applicable payment gateway and banking regulations. Upon receipt of payment, a valid invoice and receipt shall be issued to the client. All payments are subject to the company’s terms and conditions, and no adjustments, refunds, or claims shall be entertained unless explicitly agreed in writing.",
      cancellation_remarks: "We understand that sometimes unforeseen circumstances may require you to cancel or modify your travel plans, and we assure you that our intention is always to assist you in the most fair and transparent manner possible. Since every booking involves multiple service providers such as airlines, hotels, transport operators, and local suppliers, cancellation charges are determined based on their respective policies and are generally calculated on a per-person basis for bookings of two passengers, while charges for larger groups may vary accordingly. To ensure accuracy and avoid any misunderstanding, we kindly request guests to confirm the applicable cancellation charges before proceeding with a cancellation request. For your security as well as ours, all cancellation requests must be submitted in writing through our official Cancellation Request Form, which serves as a clear record of your instructions and enables us to process your request promptly with the concerned suppliers. In the event of a no-show or cancellation received after the permitted cancellation period, suppliers may impose charges up to 100% of the tour cost, leaving no refundable amount. However, in genuinely unfortunate situations such as a serious medical emergency or the death of an immediate family member, we will make every possible effort to support you by requesting a refund or future travel credit from the concerned suppliers upon receipt of valid supporting documents. While any refund or credit remains entirely subject to supplier approval and cannot be guaranteed by us, we will always try our best to represent your case sympathetically. Any approved refund will be processed as soon as it is received from the suppliers and may take one week or longer, after deducting applicable service charges, administrative costs, and non-refundable components. Our commitment is to maintain complete transparency throughout the process and to ensure that every traveller is treated fairly, respectfully, and with understanding during what can often be an unexpected and difficult situation.",
      emi_remarks: "The Equated Monthly Instalment (EMI) indicated for the tour is strictly applicable to the quoted price of the specified itinerary only. Any modification to the itinerary, including but not limited to an upgrade in hotel category or an increase in the number of travellers, shall result in a revision of the total tour cost and, consequently, the EMI amount. EMIs are generally computed on a standard tenure of 12 months; however, higher loan amounts may be structured for extended tenures of up to 48 months, subject to bank policies. The final EMI amount, applicable interest rate, and loan tenure shall be determined solely based on the sanctioned loan amount and the tenure selected by the applicant, and the applicant expressly acknowledges that interest rates may vary depending on the loan value and prevailing banking norms. All EMI facilities are subject to final tour pricing and approval by the concerned bank or financial institution, which is exclusively assessed on the applicant’s CIBIL/credit score and internal credit evaluation criteria. Loan approval, rejection, interest rates, and terms are entirely at the sole discretion of the lending institution, and S K Tours & Travels shall have no role, responsibility, or influence in the sanctioning, modification, or rejection of the loan. A non-refundable processing fee of ₹500 shall be payable if a loan application is initiated, regardless of approval status, and any additional charges including but not limited to bank charges, agreement charges, stamp duty, or statutory levies shall be borne entirely by the applicant.",
      optional_tour_remarks: "Optional tours are subject to availability at the destination, and for certain activities, adult and child pricing may be the same. Please note that jungle safaris are charged on a private vehicle basis rather than per person. We therefore request guests to confirm the applicable rates with us prior to booking any optional activities. Kindly be informed that once an optional tour is confirmed and tickets are purchased, the activity becomes non-refundable, even in the event of a cancellation, as these arrangements are made in advance with local service providers. We appreciate your understanding in this regard.",
      instruction_remarks: "For your comfort, safety, and convenience during the tour, we recommend travelling light and carrying clothing suitable for the season and destination. Guests should ensure that all essential personal medications are carried along with valid prescriptions and, in case of any medical condition that may affect independent travel, obtain a fitness certificate from their doctor or consider travelling with a companion who can provide assistance if required. We also strongly recommend purchasing adequate travel insurance prior to departure, as all medical, emergency, and hospitalization expenses incurred during the tour will be the responsibility of the traveller. While we will make every reasonable effort to assist in locating appropriate medical help whenever required, please understand that our local representatives and guides can offer only limited assistance in cases involving hospitalization, and the tour itinerary may continue as scheduled. To enable us to respond quickly and responsibly in the unlikely event of an emergency, we kindly request all guests to provide the contact details of an immediate family member and, wherever applicable, their treating doctor. This information is requested purely as a precautionary measure and allows us to communicate promptly with the appropriate person should any urgent situation arise while you are travelling. Passengers travelling by air should carry all essential electronic items, including mobile phones, laptops, chargers, and power banks, in their hand baggage, subject to airline regulations, while hazardous materials are strictly prohibited. Battery-operated items should not be packed in check-in baggage unless permitted by airline guidelines. Additionally, liquids, gels, perfumes, liquid medicines, scissors, nail cutters, toothpaste, and similar items should be packed in check-in baggage only, as such items may be confiscated by airport security if carried in hand baggage. We therefore request all travellers to carefully follow airline and airport security regulations to ensure a smooth, safe, and hassle-free travel experience"
    }));

    // Prefill tourist visa remarks (same content as Group tour)
    setTouristVisaRemarks(
      "Visa assistance services provided by the Company are categorized under Visa on Arrival, E-Visa, and Stamp Visa. The Company acts solely as a facilitator and consultant for visa-related services and does not possess any authority to grant, approve, reject, or influence visa decisions, which remain the exclusive prerogative of the respective Embassy, Consulate, Immigration Department, or Government Authority.\n\n" +
      "1. Visa on Arrival\n" +
      "For destinations offering Visa on Arrival facilities, the Client may be required by immigration authorities to carry a minimum amount of foreign currency, generally not less than USD 500 or such amount as may be prescribed by the destination country, as proof of financial capability. The Client shall also be solely responsible for paying any applicable visa fees, taxes, or charges directly to the immigration authorities at the port of entry.\n\n" +
      "2. E-Visa Requirements\n" +
      "Where an E-Visa is issued, the Client must retain and carry the approved E-Visa in electronic format on a mobile device and/or as a printed hard copy and present the same upon demand by immigration authorities, airlines, or any competent authority during the journey.\n\n" +
      "3. Verification of Visa Details\n" +
      "Upon receipt of any visa, irrespective of its category, it shall be the sole responsibility and moral obligation of the Client to carefully verify and confirm the accuracy of all particulars appearing on the visa, including but not limited to the name, passport number, nationality, date of birth, validity period, number of entries, and all other relevant details. Any typographical, clerical, alphabetical, numerical, or factual error, however minor, may result in denial of boarding, refusal of entry, detention, deportation, or any other action by immigration authorities. The Company shall not be liable for any consequences arising from the Client's failure to verify such details before commencement of travel.\n\n" +
      "4. Submission of Documents\n" +
      "The Client expressly acknowledges and agrees that submission of documents for visa processing does not constitute or imply any assurance, representation, warranty, or guarantee of visa approval. The final decision regarding the grant, refusal, validity, duration, or conditions of any visa rests solely and exclusively with the concerned immigration authorities.\n" +
      "The Client shall be solely responsible for providing complete, accurate, authentic, valid, and genuine documents and information. Any incomplete, incorrect, misleading, forged, fabricated, fraudulent, or misrepresented documentation may result in visa refusal, cancellation, blacklisting, deportation, legal action, or any other consequences imposed by the relevant authorities, for which the Company shall bear no responsibility or liability whatsoever.\n\n" +
      "5. Additional Documentation\n" +
      "The Client acknowledges that immigration authorities, embassies, consulates, or government agencies may request additional documents, personal interviews, biometric submissions, financial records, travel history, or any other supporting information at any stage of the visa process. The Client undertakes to comply promptly with all such requirements. Any delay, refusal, or failure by the Client to provide the requested information shall be solely at the Client's risk and responsibility.\n\n" +
      "6. Non-Refundable Charges\n" +
      "All visa fees, embassy fees, government charges, service fees, consultation charges, courier charges, documentation charges, and any ancillary expenses incurred for visa processing shall be strictly non-refundable under any circumstances, irrespective of visa approval, refusal, delay, cancellation, withdrawal of application, change in travel plans, or any other reason whatsoever.\n\n" +
      "7. Limitation of Liability\n" +
      "The Client expressly acknowledges and agrees that the Company acts only as an intermediary, facilitator, and consultant for visa-related services and shall not be held responsible or liable for any visa refusal, delay, cancellation, administrative processing, change in visa conditions, denial of boarding, denial of entry, deportation, detention, financial loss, business loss, consequential damages, travel disruption, accommodation loss, or any other direct or indirect loss arising out of or connected with any decision taken by immigration authorities, embassies, consulates, airlines, or government agencies.\n\n" +
      "8. Waiver of Claims\n" +
      "By availing of the Company's services and proceeding with the visa application process, the Client voluntarily accepts and acknowledges all risks associated with visa processing and further agrees not to initiate, maintain, or pursue any legal proceedings, claims, complaints, compensation demands, disputes, or actions of any nature whatsoever against the Company, its directors, employees, representatives, associates, or agents in relation to any visa decision or action taken by the concerned authorities.\n\n" +
      "By reading this, the Client confirms that he/she has read, understood, accepted, and agreed to be bound by the above terms and conditions in their entirety. If the Client has not read the terms, he/she cannot hold our company liable for any Visa rejections or non-refundable visa fees and service charges."
    );

    // Prefill Booking Policy if empty
    if (bookingPois.length === 0) {
      setBookingPois([
        {
          item: "Per Person Booking Amount",
          amount_details: ""
        },
        {
          item: "30 Days Prior Per person cost ",
          amount_details: "50 % of the tour cost"
        },
        {
          item: "21 Days Prior Per person cost",
          amount_details: "Balance amount to pay"
        }
      ]);
    }

    // Prefill Cancellation Policy if empty
    if (cancelPolicies.length === 0) {
      setCancelPolicies([
        {
          cancellation_policy: "45 Days to 30 Days Cost per person ",
          charges: ""
        },
        {
          cancellation_policy: "30 Days to 21 Days Cost per person ",
          charges: "50% of tour cost"
        },
        {
          cancellation_policy: "21 Days till Departure date Cost per person",
          charges: "100 % Cancellation applies"
        }
      ]);
    }
  }
}, [isEditMode]); // Run only once when component mounts

  // =======================
  // INSTRUCTIONS
  // =======================
  const [instructionText, setInstructionText] = useState('');
  const [instructions, setInstructions] = useState([]);

  const addInstruction = () => {
    const txt = instructionText.trim();
    if (!txt) return;
    
    if (editingInstructionIndex !== -1) {
      // Update existing
      const updated = [...instructions];
      updated[editingInstructionIndex] = txt;
      setInstructions(updated);
      setEditingInstructionIndex(-1);
      setSuccess('Instruction updated successfully');
    } else {
      // Add new
      setInstructions(prev => [...prev, txt]);
      setSuccess('Instruction added successfully');
    }
    
    setInstructionText('');
  };

  const editInstruction = (idx) => {
    const instruction = instructions[idx];
    setInstructionText(instruction);
    setEditingInstructionIndex(idx);
  };

  const removeInstruction = (idx) => {
    const confirmDelete = window.confirm('Are you sure you want to remove this instruction?');
    if (confirmDelete) {
      setInstructions(prev => prev.filter((_, i) => i !== idx));
      if (editingInstructionIndex === idx) {
        setEditingInstructionIndex(-1);
        setInstructionText('');
      }
    }
  };

  // ITINERARIES
  const [itineraryItem, setItineraryItem] = useState({
    day: '',
    title: '',
    description: '',
    meals: {
      breakfast: false,
      lunch: false,
      dinner: false
    }
  });
  const [itineraries, setItineraries] = useState([]);

  // Edit function for itineraries
const editItinerary = (idx) => {
  const item = itineraries[idx];
  
  // Parse meals string back to checkboxes
  const mealsArray = item.meals ? item.meals.split(', ') : [];
  const meals = {
    breakfast: mealsArray.includes('Breakfast'),
    lunch: mealsArray.includes('Lunch'),
    dinner: mealsArray.includes('Dinner')
  };
  
  setItineraryItem({
    day: item.day,
    title: item.title,
    description: item.description || '',
    meals: meals
  });
  
  // Set editing state instead of removing immediately
  setEditingItineraryIndex(idx);
};

  // Fetch dropdowns and tour data
 useEffect(() => {
  const loadDropdownsAndTourCode = async () => {
    try {
      // Load dropdowns
      const catRes = await fetch(`${baseurl}/api/categories/all-tours`);
      const categoryData = await catRes.json();
      setCategories(Array.isArray(categoryData) ? categoryData : []);

      const destRes = await fetch(`${baseurl}/api/destinations`);
      const destData = await destRes.json();

      // Filter for international destinations only (is_domestic == 0)
      const internationalDestinations = Array.isArray(destData) 
        ? destData.filter(destination => destination.is_domestic == 0)
        : [];
      
      // Sort destinations by name in ascending order (A to Z)
      const sortedDestinations = internationalDestinations.sort((a, b) => {
        const nameA = a.name ? a.name.toLowerCase() : '';
        const nameB = b.name ? b.name.toLowerCase() : '';
        
        if (nameA < nameB) return -1;
        if (nameA > nameB) return 1;
        return 0;
      });
      
      setDestinations(sortedDestinations);

      if (isEditMode) {
        // Load existing tour data for edit
        await loadTourData();
      } else {
        // Set is_international to 1 for international tours
        setFormData(prev => ({
          ...prev,
          is_international: 1
        }));
        
        // Fetch tour code with is_international=1 parameter
        // Note: The tour_type should be "seniorcitizen" as per your formData
        const tourCodeRes = await fetch(
          `${baseurl}/api/tours/next-tour-code?tour_type=seniorcitizen&is_international=1`
        );
        
        if (tourCodeRes.ok) {
          const tourCodeData = await tourCodeRes.json();
          setFormData(prev => ({
            ...prev,
            tour_code: tourCodeData.next_tour_code,
            is_international: 1
          }));
        } else {
          // Fallback or handle error
          console.error('Failed to fetch tour code');
        }
      }
    } catch (err) {
      setError('Failed to load dropdown data');
    }
  };

  loadDropdownsAndTourCode();
}, [id]);

  // Load tour data for editing - UPDATED TO INCLUDE HOTEL PRICE FIELDS
  const loadTourData = async () => {
    try {
      setLoading(true);
      setError('');
      
      const response = await fetch(`${baseurl}/api/tours/tour/full/seniorcitizen/${id}`);
      if (!response.ok) throw new Error('Failed to fetch tour data');
      
      const data = await response.json();
      
      if (data.success) {
        const basic = data.basic_details;
        setFormData({
          tour_code: basic.tour_code || '',
          tour_type: basic.tour_type || 'seniorcitizen',
          title: basic.title || '',
          category_id: basic.category_id || 1,
          primary_destination_id: basic.primary_destination_id || '',
           country_id: basic.country_id || '', // Add this
          duration_days: basic.duration_days || '',
          overview: basic.overview || '',
          base_price_adult: basic.base_price_adult || '',
          emi_price: basic.emi_price || '', // ← Add this line
          is_international: basic.is_international || 0,
          cost_remarks: basic.cost_remarks || '',
          hotel_remarks: basic.hotel_remarks || '',
          transport_remarks: basic.transport_remarks || '',
          booking_poi_remarks: basic.booking_poi_remarks || '',
          cancellation_remarks: basic.cancellation_remarks || '',
          emi_remarks: basic.emi_remarks || '',
            optional_tour_remarks: basic.optional_tour_remarks || '', // ← ADD THIS LINE
          departure_remarks: basic.departure_remarks || '',           // NEW
          instruction_remarks: basic.instruction_remarks || ''        // NEW
        });

        // Set itineraries
        if (data.itinerary && Array.isArray(data.itinerary)) {
          const formattedItineraries = data.itinerary.map(item => ({
            day: item.day,
            title: item.title,
            description: item.description || '',
            meals: item.meals || ''
          }));
          setItineraries(formattedItineraries);
        }

        // Set departures - Now with hotel price fields like Ladies Tour
        if (data.departures && Array.isArray(data.departures)) {
          const formattedDepartures = data.departures.map(dept => ({
            start_date: dept.start_date ? dept.start_date.split('T')[0] : '',
            end_date: dept.end_date ? dept.end_date.split('T')[0] : '',
            status: dept.status || 'Available',
            total_seats: dept.total_seats || 40,
            booked_seats: dept.booked_seats || 0,
            description: dept.description || '',
            // 3-Star Hotel Prices
            three_star_twin: dept.three_star_twin || '',
            three_star_triple: dept.three_star_triple || '',
            three_star_child_with_bed: dept.three_star_child_with_bed || '',
            three_star_child_without_bed: dept.three_star_child_without_bed || '',
            three_star_infant: dept.three_star_infant || '',
            three_star_single: dept.three_star_single || '',
            // 4-Star Hotel Prices
            four_star_twin: dept.four_star_twin || '',
            four_star_triple: dept.four_star_triple || '',
            four_star_child_with_bed: dept.four_star_child_with_bed || '',
            four_star_child_without_bed: dept.four_star_child_without_bed || '',
            four_star_infant: dept.four_star_infant || '',
            four_star_single: dept.four_star_single || '',
            // 5-Star Hotel Prices
            five_star_twin: dept.five_star_twin || '',
            five_star_triple: dept.five_star_triple || '',
            five_star_child_with_bed: dept.five_star_child_with_bed || '',
            five_star_child_without_bed: dept.five_star_child_without_bed || '',
            five_star_infant: dept.five_star_infant || '',
            five_star_single: dept.five_star_single || ''
          }));
          setDepartures(formattedDepartures);
        }

        // Set inclusions
        if (data.inclusions && Array.isArray(data.inclusions)) {
          const inclusionItems = data.inclusions.map(inc => inc.item);
          setInclusions(inclusionItems);
        }

        // Set exclusions
        if (data.exclusions && Array.isArray(data.exclusions)) {
          const exclusionItems = data.exclusions.map(exc => exc.item);
          setExclusions(exclusionItems);
        }

        // Set optional tours
        if (data.optional_tours && Array.isArray(data.optional_tours)) {
          setOptionalTours(data.optional_tours);
        }

        // Set EMI options
        if (data.emi_options && Array.isArray(data.emi_options)) {
          const defaultOptions = [
            { particulars: 'Per Month Payment', months: 6, loan_amount: '', emi: '' },
            { particulars: 'Per Month Payment', months: 12, loan_amount: '', emi: '' },
            { particulars: 'Per Month Payment', months: 18, loan_amount: '', emi: '' },
            { particulars: 'Per Month Payment', months: 24, loan_amount: '', emi: '' },
            { particulars: 'Per Month Payment', months: 30, loan_amount: '', emi: '' },
            { particulars: 'Per Month Payment', months: 36, loan_amount: '', emi: '' },
            { particulars: 'Per Month Payment', months: 48, loan_amount: '', emi: '' }
          ];

          const updatedOptions = defaultOptions.map(option => {
            const existingOption = data.emi_options.find(eo => eo.months === option.months);
            return existingOption ? {
              ...option,
              loan_amount: existingOption.loan_amount || '',
              emi: existingOption.emi || ''
            } : option;
          });

          setEmiOptions(updatedOptions);
        }

        // Set hotels
          // Set hotels
       if (data.hotels && Array.isArray(data.hotels)) {
          const formattedHotels = data.hotels.map(hotel => ({
            ...hotel,
            standard_hotel_name: hotel.standard_hotel_name || '',
            deluxe_hotel_name: hotel.deluxe_hotel_name || '',
            executive_hotel_name: hotel.executive_hotel_name || ''
          }));
          setHotelRows(formattedHotels);
        }
        // In loadTourData function, add this after loading other data:

              // Load Visa Data - Add this section
         // Load Visa Data

          // Load Visa Data - Add this section
      if (data.visa_details && Array.isArray(data.visa_details)) {
        // Filter and set Tourist Visa items
        const touristVisaData = data.visa_details.filter(item => item.type === 'tourist');
        setTouristVisaItems(touristVisaData.map(item => ({ description: item.description })));
        
        // Filter and set Transit Visa items
        const transitVisaData = data.visa_details.filter(item => item.type === 'transit');
        setTransitVisaItems(transitVisaData.map(item => ({ description: item.description })));
        
        // Filter and set Business Visa items
        const businessVisaData = data.visa_details.filter(item => item.type === 'business');
        setBusinessVisaItems(businessVisaData.map(item => ({ description: item.description })));
        
        // Filter and set Photo items
        const photoData = data.visa_details.filter(item => item.type === 'photo');
        setPhotoItems(photoData.map(item => ({ description: item.description })));
      }
      
      // Load Visa Forms - Update this part
      if (data.visa_forms && Array.isArray(data.visa_forms)) {
        const formattedForms = data.visa_forms.map(form => ({
          type: form.visa_type,
          // download_text: form.download_text,
          download_action: form.download_action,
          fill_action: form.fill_action,
          action1_file: form.action1_file, // Keep the filename string
          action2_file: form.action2_file, // Keep the filename string
          action1_file_url: form.action1_file_url || null,
          action2_file_url: form.action2_file_url || null
        }));
        setVisaFormItems(formattedForms);
        
        // Load remarks from the first visa form
        if (data.visa_forms.length > 0 && data.visa_forms[0].remarks) {
          setTouristVisaRemarks(data.visa_forms[0].remarks);
        }
      }
      
      // Load Visa Fees - Update this part
      if (data.visa_fees && Array.isArray(data.visa_fees)) {
        // Create Visa Fees rows with separate charges
        const visaFeeRows = data.visa_fees.map(fee => ({
          id: fee.fee_id || fee.id,
          type: fee.row_type,
          tourist: fee.tourist || '',
          transit: fee.transit || '',
          business: fee.business || '',
          tourist_charges: fee.tourist_charges || '',
          transit_charges: fee.transit_charges || '',
          business_charges: fee.business_charges || ''
        }));
        setVisaFeesRows(visaFeeRows);
      }
      
      // Load Submission Data - Update this part
      if (data.visa_submission && Array.isArray(data.visa_submission)) {
        const submissionRows = data.visa_submission.map(item => ({
          id: item.submission_id || item.id,
          label: item.label || '',
          tourist: item.tourist || '',
          transit: item.transit || '',
          business: item.business || ''
        }));
        setSubmissionRows(submissionRows);
      }



        // Set transport
             // Set transport
if (data.transport && Array.isArray(data.transport)) {
  const formattedTransports = data.transport.map(transport => ({
    ...transport,
    from_date: transport.from_date ? transport.from_date.split('T')[0] : '',
    to_date: transport.to_date ? transport.to_date.split('T')[0] : '',
    // Keep time fields as they are
    from_time: transport.from_time || '',
    to_time: transport.to_time || ''
  }));
  setTransports(formattedTransports);
}

        // Set booking POI
        if (data.booking_poi && Array.isArray(data.booking_poi)) {
          const formattedPois = data.booking_poi.map(poi => ({
            item: poi.item,
            amount_details: poi.amount_details || ''
          }));
          setBookingPois(formattedPois);
        }

        // Set cancellation policies
        if (data.cancellation_policies && Array.isArray(data.cancellation_policies)) {
          const formattedPolicies = data.cancellation_policies.map(policy => ({
            cancellation_policy: policy.cancellation_policy,
            charges: policy.charges || ''
          }));
          setCancelPolicies(formattedPolicies);
        }

        // Set instructions
        if (data.instructions && Array.isArray(data.instructions)) {
          const instructionItems = data.instructions.map(inst => inst.item);
          setInstructions(instructionItems);
        }

        // Set images (previews only, not files)
    if (data.images && Array.isArray(data.images)) {
            const imageUrls = data.images.map(img => img.url);
            // Keep existing images separately
            setExistingImages(data.images);
            // Set previews for new uploads (empty if no new files)
            setImagePreviews([]);
          }

        setSuccess('Tour data loaded successfully');
      }
    } catch (err) {
      setError('Failed to load tour data: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  // BASIC DETAILS CHANGE
  const handleBasicChange = (e) => {
    const { name, value } = e.target;

    const numericFields = [
      'duration_days',
      'base_price_adult',
      'emi_price', // ← Add this line
      'category_id',
      'primary_destination_id',
      'country_id', // Add this
      'is_international'
    ];

    const finalValue = numericFields.includes(name)
      ? value === '' ? '' : Number(value)
      : value;

    setFormData((prev) => ({
      ...prev,
      [name]: finalValue
    }));
  };

  // DEPARTURE FORM CHANGE - UPDATED WITH HOTEL PRICE FIELDS
  const handleSeniorDepartureChange = (e) => {
    const { name, value } = e.target;
    const numericFields = [
      'total_seats', 'booked_seats',
      'three_star_twin', 'three_star_triple', 'three_star_child_with_bed',
      'three_star_child_without_bed', 'three_star_infant', 'three_star_single',
      'four_star_twin', 'four_star_triple', 'four_star_child_with_bed',
      'four_star_child_without_bed', 'four_star_infant', 'four_star_single',
      'five_star_twin', 'five_star_triple', 'five_star_child_with_bed',
      'five_star_child_without_bed', 'five_star_infant', 'five_star_single'
    ];

    setSeniorDepartureForm((prev) => ({
      ...prev,
      [name]: numericFields.includes(name)
        ? value === '' ? '' : Number(value)
        : value
    }));
  };

// ============================================================
// FIXED: handleAddDeparture - Prefills from current form values
// ============================================================
const handleAddDeparture = () => {
  if (!seniorDepartureForm.start_date || !seniorDepartureForm.end_date) {
    setError('Please enter both start and end dates');
    return;
  }

  // Store the current form values before any state updates
  const currentFormValues = { ...seniorDepartureForm };

  // Ensure all price fields are numbers or null
  const departureData = {
    ...currentFormValues,
    start_date: currentFormValues.start_date,
    end_date: currentFormValues.end_date,
    status: currentFormValues.status || 'Available',
    total_seats: currentFormValues.total_seats || 40,
    booked_seats: currentFormValues.booked_seats || 0,
    description: currentFormValues.description || '',
    // 3-Star Hotel Prices
    three_star_twin: currentFormValues.three_star_twin ? Number(currentFormValues.three_star_twin) : null,
    three_star_triple: currentFormValues.three_star_triple ? Number(currentFormValues.three_star_triple) : null,
    three_star_child_with_bed: currentFormValues.three_star_child_with_bed ? Number(currentFormValues.three_star_child_with_bed) : null,
    three_star_child_without_bed: currentFormValues.three_star_child_without_bed ? Number(currentFormValues.three_star_child_without_bed) : null,
    three_star_infant: currentFormValues.three_star_infant ? Number(currentFormValues.three_star_infant) : null,
    three_star_single: currentFormValues.three_star_single ? Number(currentFormValues.three_star_single) : null,
    // 4-Star Hotel Prices
    four_star_twin: currentFormValues.four_star_twin ? Number(currentFormValues.four_star_twin) : null,
    four_star_triple: currentFormValues.four_star_triple ? Number(currentFormValues.four_star_triple) : null,
    four_star_child_with_bed: currentFormValues.four_star_child_with_bed ? Number(currentFormValues.four_star_child_with_bed) : null,
    four_star_child_without_bed: currentFormValues.four_star_child_without_bed ? Number(currentFormValues.four_star_child_without_bed) : null,
    four_star_infant: currentFormValues.four_star_infant ? Number(currentFormValues.four_star_infant) : null,
    four_star_single: currentFormValues.four_star_single ? Number(currentFormValues.four_star_single) : null,
    // 5-Star Hotel Prices
    five_star_twin: currentFormValues.five_star_twin ? Number(currentFormValues.five_star_twin) : null,
    five_star_triple: currentFormValues.five_star_triple ? Number(currentFormValues.five_star_triple) : null,
    five_star_child_with_bed: currentFormValues.five_star_child_with_bed ? Number(currentFormValues.five_star_child_with_bed) : null,
    five_star_child_without_bed: currentFormValues.five_star_child_without_bed ? Number(currentFormValues.five_star_child_without_bed) : null,
    five_star_infant: currentFormValues.five_star_infant ? Number(currentFormValues.five_star_infant) : null,
    five_star_single: currentFormValues.five_star_single ? Number(currentFormValues.five_star_single) : null
  };

  // Determine if we're editing or adding
  const isEditing = editingDepartureIndex !== -1;

  if (isEditing) {
    // Update existing departure
    const updatedDepartures = [...departures];
    updatedDepartures[editingDepartureIndex] = departureData;
    setDepartures(updatedDepartures);
    setEditingDepartureIndex(-1);
    setSuccess('Departure updated successfully');
  } else {
    // Add new departure
    setDepartures((prev) => [...prev, departureData]);
    setSuccess('Departure with costs added successfully');
  }

  // ============================================================
  // FIXED: After adding/updating, reset the form but KEEP the cost values
  // so the user can add another departure with the same costs
  // ============================================================
  // Reset only the date and seat fields, keep all cost values
  setSeniorDepartureForm({
    start_date: '',
    end_date: '',
    status: currentFormValues.status || 'Available',
    total_seats: currentFormValues.total_seats || 40,
    booked_seats: 0, // Reset booked seats for new departure
    description: currentFormValues.description || '',
    // 3-Star Hotel Prices - KEEP THE SAME VALUES
    three_star_twin: currentFormValues.three_star_twin || '',
    three_star_triple: currentFormValues.three_star_triple || '',
    three_star_child_with_bed: currentFormValues.three_star_child_with_bed || '',
    three_star_child_without_bed: currentFormValues.three_star_child_without_bed || '',
    three_star_infant: currentFormValues.three_star_infant || '',
    three_star_single: currentFormValues.three_star_single || '',
    // 4-Star Hotel Prices - KEEP THE SAME VALUES
    four_star_twin: currentFormValues.four_star_twin || '',
    four_star_triple: currentFormValues.four_star_triple || '',
    four_star_child_with_bed: currentFormValues.four_star_child_with_bed || '',
    four_star_child_without_bed: currentFormValues.four_star_child_without_bed || '',
    four_star_infant: currentFormValues.four_star_infant || '',
    four_star_single: currentFormValues.four_star_single || '',
    // 5-Star Hotel Prices - KEEP THE SAME VALUES
    five_star_twin: currentFormValues.five_star_twin || '',
    five_star_triple: currentFormValues.five_star_triple || '',
    five_star_child_with_bed: currentFormValues.five_star_child_with_bed || '',
    five_star_child_without_bed: currentFormValues.five_star_child_without_bed || '',
    five_star_infant: currentFormValues.five_star_infant || '',
    five_star_single: currentFormValues.five_star_single || ''
  });
  
  // Reset editing state
  setEditingDepartureIndex(-1);
};

 const editDeparture = (idx) => {
  const departure = departures[idx];
  // Set ALL departure fields including costs
  setSeniorDepartureForm({
    start_date: departure.start_date || '',
    end_date: departure.end_date || '',
    status: departure.status || 'Available',
    total_seats: departure.total_seats || 40,
    booked_seats: departure.booked_seats || 0,
    description: departure.description || '',
    // 3-Star Hotel Prices
    three_star_twin: departure.three_star_twin || '',
    three_star_triple: departure.three_star_triple || '',
    three_star_child_with_bed: departure.three_star_child_with_bed || '',
    three_star_child_without_bed: departure.three_star_child_without_bed || '',
    three_star_infant: departure.three_star_infant || '',
    three_star_single: departure.three_star_single || '',
    // 4-Star Hotel Prices
    four_star_twin: departure.four_star_twin || '',
    four_star_triple: departure.four_star_triple || '',
    four_star_child_with_bed: departure.four_star_child_with_bed || '',
    four_star_child_without_bed: departure.four_star_child_without_bed || '',
    four_star_infant: departure.four_star_infant || '',
    four_star_single: departure.four_star_single || '',
    // 5-Star Hotel Prices
    five_star_twin: departure.five_star_twin || '',
    five_star_triple: departure.five_star_triple || '',
    five_star_child_with_bed: departure.five_star_child_with_bed || '',
    five_star_child_without_bed: departure.five_star_child_without_bed || '',
    five_star_infant: departure.five_star_infant || '',
    five_star_single: departure.five_star_single || ''
  });
  
  // Set editing state
  setEditingDepartureIndex(idx);
};

const handleRemoveDeparture = (idx) => {
  const confirmDelete = window.confirm('Are you sure you want to remove this departure?');
  if (confirmDelete) {
    setDepartures(prev => prev.filter((_, i) => i !== idx));
    // If we're removing the one being edited, cancel edit
    if (editingDepartureIndex === idx) {
      setEditingDepartureIndex(-1);
      // Reset with default values
      setSeniorDepartureForm({
        start_date: '',
        end_date: '',
        status: 'Available',
        total_seats: 40,
        booked_seats: 0,
        description: '',
        three_star_twin: '',
        three_star_triple: '',
        three_star_child_with_bed: '',
        three_star_child_without_bed: '',
        three_star_infant: '',
        three_star_single: '',
        four_star_twin: '',
        four_star_triple: '',
        four_star_child_with_bed: '',
        four_star_child_without_bed: '',
        four_star_infant: '',
        four_star_single: '',
        five_star_twin: '',
        five_star_triple: '',
        five_star_child_with_bed: '',
        five_star_child_without_bed: '',
        five_star_infant: '',
        five_star_single: ''
      });
    } else if (departures.length > 1 && idx === 0) {
      // If we removed the first departure but there are others, prefill with the new first departure
      const remainingDepartures = departures.filter((_, i) => i !== idx);
      if (remainingDepartures.length > 0) {
        const firstDeparture = remainingDepartures[0];
        setSeniorDepartureForm({
          start_date: '',
          end_date: '',
          status: firstDeparture.status || 'Available',
          total_seats: firstDeparture.total_seats || 40,
          booked_seats: 0,
          description: firstDeparture.description || '',
          three_star_twin: firstDeparture.three_star_twin || '',
          three_star_triple: firstDeparture.three_star_triple || '',
          three_star_child_with_bed: firstDeparture.three_star_child_with_bed || '',
          three_star_child_without_bed: firstDeparture.three_star_child_without_bed || '',
          three_star_infant: firstDeparture.three_star_infant || '',
          three_star_single: firstDeparture.three_star_single || '',
          four_star_twin: firstDeparture.four_star_twin || '',
          four_star_triple: firstDeparture.four_star_triple || '',
          four_star_child_with_bed: firstDeparture.four_star_child_with_bed || '',
          four_star_child_without_bed: firstDeparture.four_star_child_without_bed || '',
          four_star_infant: firstDeparture.four_star_infant || '',
          four_star_single: firstDeparture.four_star_single || '',
          five_star_twin: firstDeparture.five_star_twin || '',
          five_star_triple: firstDeparture.five_star_triple || '',
          five_star_child_with_bed: firstDeparture.five_star_child_with_bed || '',
          five_star_child_without_bed: firstDeparture.five_star_child_without_bed || '',
          five_star_infant: firstDeparture.five_star_infant || '',
          five_star_single: firstDeparture.five_star_single || ''
        });
      }
    }
  }
};

  // EXCLUSIONS
  const handleAddExclusion = () => {
  const trimmed = exclusionText.trim();
  if (!trimmed) return;
  
  if (editingExclusionIndex !== -1) {
    // Update existing
    const updated = [...exclusions];
    updated[editingExclusionIndex] = trimmed;
    setExclusions(updated);
    setEditingExclusionIndex(-1);
    setSuccess('Exclusion updated successfully');
  } else {
    // Add new
    setExclusions((prev) => [...prev, trimmed]);
    setSuccess('Exclusion added successfully');
  }
  
  setExclusionText('');
};

const editExclusion = (idx) => {
  const exclusion = exclusions[idx];
  setExclusionText(exclusion);
  setEditingExclusionIndex(idx);
};

const handleRemoveExclusion = (idx) => {
  const confirmDelete = window.confirm('Are you sure you want to remove this exclusion?');
  if (confirmDelete) {
    setExclusions(prev => prev.filter((_, i) => i !== idx));
    if (editingExclusionIndex === idx) {
      setEditingExclusionIndex(-1);
      setExclusionText('');
    }
  }
};
 const handleAddInclusion = () => {
  const trimmed = inclusionText.trim();
  if (!trimmed) return;
  
  if (editingInclusionIndex !== -1) {
    // Update existing
    const updated = [...inclusions];
    updated[editingInclusionIndex] = trimmed;
    setInclusions(updated);
    setEditingInclusionIndex(-1);
    setSuccess('Inclusion updated successfully');
  } else {
    // Add new
    setInclusions((prev) => [...prev, trimmed]);
    setSuccess('Inclusion added successfully');
  }
  
  setInclusionText('');
};

const editInclusion = (idx) => {
  const inclusion = inclusions[idx];
  setInclusionText(inclusion);
  setEditingInclusionIndex(idx);
};

const handleRemoveInclusion = (idx) => {
  const confirmDelete = window.confirm('Are you sure you want to remove this inclusion?');
  if (confirmDelete) {
    setInclusions(prev => prev.filter((_, i) => i !== idx));
    if (editingInclusionIndex === idx) {
      setEditingInclusionIndex(-1);
      setInclusionText('');
    }
  }
};


  // IMAGES
  const handleImageChange = (e) => {
    const files = e.target.files ? Array.from(e.target.files) : [];
    setImageFiles(files);

    const previews = files.map((file) => URL.createObjectURL(file));
    setImagePreviews(prev => [...prev, ...previews]);
  };

  // Handle file selection for replacement
  const handleReplacementFileChange = (e) => {
    const file = e.target.files ? e.target.files[0] : null;
    setReplacementFile(file);
    if (file) {
      const preview = URL.createObjectURL(file);
      setReplacementPreview(preview);
    }
  };
  
  
  // Update existing image (replace with new file)
  const updateImage = async (imageId) => {
    if (!replacementFile) {
      alert('Please select a new image file to replace the existing one');
      return;
    }
  
    try {
      setLoading(true);
      setError('');
      
      // First delete the old image
      const deleteResponse = await fetch(`${baseurl}/api/images/${imageId}`, {
        method: 'DELETE'
      });
      
      if (!deleteResponse.ok) {
        throw new Error('Failed to delete old image');
      }
  
      // Then upload the new image
      const formData = new FormData();
      formData.append('images', replacementFile);
      if (imageCaption.trim()) {
        formData.append('caption', imageCaption.trim());
      }
      
      const uploadResponse = await fetch(`${baseurl}/api/images/upload/${id}`, {
        method: 'POST',
        body: formData
      });
  
      if (!uploadResponse.ok) {
        throw new Error('Failed to upload new image');
      }
  
      // Refresh the images list
      await loadTourData();
      
      setSuccess('Image updated successfully');
      cancelEditImage();
    } catch (err) {
      setError('Failed to update image: ' + err.message);
    } finally {
      setLoading(false);
    }
  };
  
  // Delete image
  const deleteImage = async (imageId) => {
    const confirmDelete = window.confirm('Are you sure you want to delete this image?');
    if (!confirmDelete) return;
  
    try {
      setLoading(true);
      setError('');
      
      const response = await fetch(`${baseurl}/api/images/${imageId}`, {
        method: 'DELETE'
      });
      
      if (!response.ok) {
        throw new Error('Failed to delete image');
      }
  
      // Update local state
      setExistingImages(prev => prev.filter(img => img.image_id !== imageId));
      
      setSuccess('Image deleted successfully');
    } catch (err) {
      setError('Failed to delete image: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  // Set cover image
  const setCoverImage = async (imageId) => {
    try {
      setLoading(true);
      setError('');
      
      const response = await fetch(`${baseurl}/api/images/cover/${imageId}`, {
        method: 'PUT'
      });
      
      if (!response.ok) {
        throw new Error('Failed to set cover image');
      }
  
      // Update local state
      setExistingImages(prev => 
        prev.map(img => ({
          ...img,
          is_cover: img.image_id === imageId ? 1 : 0
        }))
      );
      
      setSuccess('Cover image updated successfully');
    } catch (err) {
      setError('Failed to set cover image: ' + err.message);
    } finally {
      setLoading(false);
    }
  };
  
  
  // Start editing an image
  const startEditImage = (image) => {
    setEditingImageId(image.image_id);
    setReplacementFile(null);
    setReplacementPreview(null);
  };
  
  // Cancel editing
  const cancelEditImage = () => {
    setEditingImageId(null);
    setReplacementFile(null);
    setReplacementPreview(null);
    // Clear the file input
    const fileInput = document.getElementById('replacementFileInput');
    if (fileInput) fileInput.value = '';
  };
  

  useEffect(() => {
    return () => {
      imagePreviews.forEach((url) => {
        if (url.startsWith('blob:')) {
          URL.revokeObjectURL(url);
        }
      });
    };
  }, [imagePreviews]);

  // ITINERARY
  const handleItineraryChange = (e) => {
    const { name, value } = e.target;

    setItineraryItem((prev) => ({
      ...prev,
      [name]: name === 'day' ? value.replace(/[^0-9]/g, '') : value
    }));
  };

  const handleMealsCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setItineraryItem((prev) => ({
      ...prev,
      meals: {
        ...prev.meals,
        [name]: checked
      }
    }));
  };

const handleAddItinerary = () => {
  const { day, title, description, meals } = itineraryItem;
  if (!day || !title.trim()) return;

  const selectedMeals = [];
  if (meals.breakfast) selectedMeals.push('Breakfast');
  if (meals.lunch) selectedMeals.push('Lunch');
  if (meals.dinner) selectedMeals.push('Dinner');

  const mealsString = selectedMeals.join(', ');

  const newItinerary = {
    day: Number(day),
    title: title.trim(),
    description: description.trim(),
    meals: mealsString
  };

  if (editingItineraryIndex !== -1) {
    // Update existing itinerary
    const updatedItineraries = [...itineraries];
    updatedItineraries[editingItineraryIndex] = newItinerary;
    setItineraries(updatedItineraries);
    setEditingItineraryIndex(-1);
    setSuccess('Itinerary updated successfully');
  } else {
    // Add new itinerary
    setItineraries((prev) => [...prev, newItinerary]);
    setSuccess('Itinerary added successfully');
  }

  // Reset form
  setItineraryItem({
    day: '',
    title: '',
    description: '',
    meals: {
      breakfast: false,
      lunch: false,
      dinner: false
    }
  });
};


const handleRemoveItinerary = (idx) => {
  const confirmDelete = window.confirm('Are you sure you want to remove this itinerary?');
  if (confirmDelete) {
    setItineraries(prev => prev.filter((_, i) => i !== idx));
    if (editingItineraryIndex === idx) {
      setEditingItineraryIndex(-1);
      setItineraryItem({
        day: '',
        title: '',
        description: '',
        meals: { breakfast: false, lunch: false, dinner: false }
      });
    }
  }
};


  // NAVIGATION
const goNext = () => {
  const currentIndex = TAB_LIST.indexOf(activeTab);
  
  // If we're on the main visa tab
  if (activeTab === 'visa') {
    // Check if there are more visa subtabs to complete
    const currentSubTabIndex = visaSubTabs.indexOf(activeVisaSubTab);
    
    // If current subtab is not the last one
    if (currentSubTabIndex < visaSubTabs.length - 1) {
      // Move to next visa subtab
      setActiveVisaSubTab(visaSubTabs[currentSubTabIndex + 1]);
      return;
    } else {
      // All visa subtabs are done, move to booking
      if (currentIndex < TAB_LIST.length - 1) {
        setActiveTab(TAB_LIST[currentIndex + 1]); // Move to bookingPoi
      }
      return;
    }
  }
  
  // Normal navigation for other tabs
  if (currentIndex < TAB_LIST.length - 1) {
    setActiveTab(TAB_LIST[currentIndex + 1]);
  }
};
const goBack = () => {
  const currentIndex = TAB_LIST.indexOf(activeTab);
  
  // If we're on the main visa tab
  if (activeTab === 'visa') {
    // Check if we can go back to previous visa subtab
    const currentSubTabIndex = visaSubTabs.indexOf(activeVisaSubTab);
    
    // If current subtab is not the first one
    if (currentSubTabIndex > 0) {
      // Move to previous visa subtab
      setActiveVisaSubTab(visaSubTabs[currentSubTabIndex - 1]);
      return;
    } else {
      // Go back to hotels tab from first visa subtab
      if (currentIndex > 0) {
        setActiveTab(TAB_LIST[currentIndex - 1]); // Move to hotels
      }
      return;
    }
  }
  
  // Normal navigation for other tabs
  if (currentIndex > 0) {
    setActiveTab(TAB_LIST[currentIndex - 1]);
  }
};

  const handleCancel = () => {
    navigate('/intl-senior-citizen-tours');
  };

  const isLastTab = activeTab === TAB_LIST[TAB_LIST.length - 1];

  // AUTO-ADD WHEN USER CLICKS SAVE & CONTINUE
  const autoAddBeforeNext = () => {
    switch (activeTab) {
      case 'itineraries':
        if (itineraryItem.day && itineraryItem.title.trim()) {
          handleAddItinerary();
        }
        break;

      case 'departures':
        if (seniorDepartureForm.start_date && seniorDepartureForm.end_date) {
          handleAddDeparture();
        }
        break;

      case 'emiOptions':
        const hasAtLeastOneValidOption = emiOptions.some(option =>
          option.loan_amount && option.loan_amount > 0 && option.emi && option.emi > 0
        );

        // if (!hasAtLeastOneValidOption) {
        //   setError('Please fill at least one EMI option before proceeding');
        //   return false;
        // }
        break;

      case 'optionalTours':
        if (optionalTourItem.tour_name && optionalTourItem.tour_name.trim()) {
          addOptionalTourRow();
        }
        break;

      case 'hotels':
        // FIXED: hotelItem.hotel_name does not exist - check the actual hotel name fields
        if (hotelItem.city.trim() && (
          hotelItem.standard_hotel_name.trim() ||
          hotelItem.deluxe_hotel_name.trim() ||
          hotelItem.executive_hotel_name.trim()
        )) {
          addHotelRow();
        }
        break;

       case 'visa':
      // Check which subtab is active
      if (activeVisaSubTab === 'tourist' && touristVisaForm.description.trim()) {
        addTouristVisa();
      } else if (activeVisaSubTab === 'transit' && transitVisaForm.description.trim()) {
        addTransitVisa();
      } else if (activeVisaSubTab === 'business' && businessVisaForm.description.trim()) {
        addBusinessVisa();
      } else if (activeVisaSubTab === 'photo' && photoForm.description.trim()) {
        addPhoto();
      }
      break;

      case 'transport':
        if (transportItem.airline && transportItem.flight_no) {
          addTransportRow();
        }
        break;

      case 'bookingPoi':
        if (poiText && poiText.trim()) {
          addPoi();
        }
        break;

      case 'cancellation':
        if (cancelItem.cancellation_policy && cancelItem.cancellation_policy.trim()) {
          addCancelRow();
        }
        break;

      case 'instructions':
        if (instructionText && instructionText.trim()) {
          addInstruction();
        }
        break;

      case 'inclusions':
        if (inclusionText && inclusionText.trim()) {
          handleAddInclusion();
        }
        break;

      case 'exclusions':
        if (exclusionText && exclusionText.trim()) {
          handleAddExclusion();
        }
        break;

      default:
        break;
    }
  };

    // UPDATE EXISTING TOUR - UPDATED FOR GROUP TOUR STRUCTURE
// UPDATE EXISTING TOUR - UPDATED WITH HOTEL PRICE FIELDS
  const updateTour = async () => {
    if (!formData.tour_code.trim()) {
      setError('Tour code is required');
      setActiveTab('basic');
      return;
    }
    if (!formData.title.trim()) {
      setError('Tour title is required');
      setActiveTab('basic');
      return;
    }

    try {
      setLoading(true);
      setError('');
      setSuccess('');

      const tourUpdateData = {
        title: formData.title.trim(),
        tour_type: formData.tour_type || 'seniorcitizen',
        primary_destination_id: formData.primary_destination_id,
         country_id: formData.country_id, // Add this
        duration_days: Number(formData.duration_days) || 0,
        overview: formData.overview || '',
        base_price_adult: Number(formData.base_price_adult) || 0,
        emi_price: Number(formData.emi_price) || 0, // ← Add this line
        is_international: Number(formData.is_international) || 0,
        cost_remarks: formData.cost_remarks || '',
        hotel_remarks: formData.hotel_remarks || '',
        transport_remarks: formData.transport_remarks || '',
        emi_remarks: formData.emi_remarks || '',
        booking_poi_remarks: formData.booking_poi_remarks || '',
        cancellation_remarks: formData.cancellation_remarks || '',
         optional_tour_remarks: formData.optional_tour_remarks || '', // ← ADD THIS LINE
        departure_remarks: formData.departure_remarks || '',          // NEW
        instruction_remarks: formData.instruction_remarks || ''       // NEW
      };

      console.log('Updating tour with data:', tourUpdateData);

      const tourRes = await fetch(`${baseurl}/api/tours/${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(tourUpdateData)
      });

      const tourResponse = await tourRes.json();
      
      if (!tourRes.ok) {
        throw new Error(tourResponse.error || tourResponse.message || 'Failed to update tour');
      }

      // DELETE EXISTING DATA
      const deleteEndpoints = [
        `${baseurl}/api/departures/bulk/${id}`,
        `${baseurl}/api/optional-tours/tour/${id}`,
        `${baseurl}/api/emi-options/tour/${id}`,
        `${baseurl}/api/tour-hotels/tour/${id}`,
        `${baseurl}/api/tour-transports/tour/${id}`,
        `${baseurl}/api/tour-booking-poi/tour/${id}`,
        `${baseurl}/api/tour-cancellation/tour/${id}`,
        `${baseurl}/api/tour-instructions/tour/${id}`,
        `${baseurl}/api/exclusions/tour/${id}`,
        `${baseurl}/api/inclusions/tour/${id}`,
        `${baseurl}/api/itineraries/tour/${id}`
      ];

      for (const endpoint of deleteEndpoints) {
        try {
          await fetch(endpoint, { method: 'DELETE' });
        } catch (err) {
          console.warn(`Failed to delete from ${endpoint}:`, err.message);
        }
      }

      // RE-ADD ALL DATA
      // Departures - Updated with hotel price fields
      if (departures.length > 0) {
        const formattedDepartures = departures.map(dept => ({
          tour_type: 'Group',
          start_date: dept.start_date,
          end_date: dept.end_date,
          status: dept.status,
          total_seats: dept.total_seats || 40,
          booked_seats: dept.booked_seats || 0,
          description: dept.description || null,
          adult_price: dept.three_star_twin || 0,
          // 3-Star Hotel Prices
          three_star_twin: dept.three_star_twin || null,
          three_star_triple: dept.three_star_triple || null,
          three_star_child_with_bed: dept.three_star_child_with_bed || null,
          three_star_child_without_bed: dept.three_star_child_without_bed || null,
          three_star_infant: dept.three_star_infant || null,
          three_star_single: dept.three_star_single || null,
          // 4-Star Hotel Prices
          four_star_twin: dept.four_star_twin || null,
          four_star_triple: dept.four_star_triple || null,
          four_star_child_with_bed: dept.four_star_child_with_bed || null,
          four_star_child_without_bed: dept.four_star_child_without_bed || null,
          four_star_infant: dept.four_star_infant || null,
          four_star_single: dept.four_star_single || null,
          // 5-Star Hotel Prices
          five_star_twin: dept.five_star_twin || null,
          five_star_triple: dept.five_star_triple || null,
          five_star_child_with_bed: dept.five_star_child_with_bed || null,
          five_star_child_without_bed: dept.five_star_child_without_bed || null,
          five_star_infant: dept.five_star_infant || null,
          five_star_single: dept.five_star_single || null
        }));

        await fetch(`${baseurl}/api/departures/bulk`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ tour_id: id, departures: formattedDepartures })
        });
      }

      // Optional Tours
      if (optionalTours.length > 0) {
        await fetch(`${baseurl}/api/optional-tours/bulk`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ tour_id: id, optional_tours: optionalTours })
        });
      }

      // EMI Options
     // 6) EMI OPTIONS - UPDATED
if (emiLoanAmount && !isNaN(emiLoanAmount) && emiLoanAmount > 0) {
  // Use the global loan amount
  await fetch(`${baseurl}/api/emi-options/emi/bulk`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ 
      tour_id: id, 
      loan_amount: emiLoanAmount 
    })
  });
} else {
  // Fallback to existing behavior if no global loan amount
  const validEmiOptions = emiOptions.filter(opt =>
    opt.loan_amount && opt.loan_amount > 0 && opt.emi && opt.emi > 0
  );
  if (validEmiOptions.length > 0) {
    await fetch(`${baseurl}/api/emi-options/emi/bulk`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ 
        tour_id: id, 
        emi_options: validEmiOptions 
      })
    });
  }
}

      // Hotels
      if (hotelRows.length > 0) {
        await fetch(`${baseurl}/api/tour-hotels/bulk`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ tour_id: id, hotels: hotelRows })
        });
      }

  // In updateTour function, fix the visa section:

// Delete existing visa data
        try {
          await fetch(`${baseurl}/api/visa/tour/${id}`, { method: 'DELETE' });
        } catch (err) {
          console.warn('Failed to delete visa data:', err.message);
        }
  
  
          // Upload visa form files FIRST
      const uploadedVisaForms = await uploadVisaFormFiles(id, visaFormItems);
  
  
        // Add visa data
        // In createTour and updateTour functions, update the visaData preparation:
  // FIXED: visa_fees / submission now use the same payload shape as createTour and Group tour
  // (row_type + row_order), and visa_forms keep filename strings.
  const visaData = {
    tourist_visa: touristVisaItems,
    transit_visa: transitVisaItems,
    business_visa: businessVisaItems,
    visa_forms: uploadedVisaForms.map(form => ({
      type: form.type,
      download_text: form.download_text,
      download_action: form.download_action,
      fill_action: form.fill_action,
      action1_file: form.action1_file, // Filename string
      action2_file: form.action2_file  // Filename string
    })), // Use the uploaded forms with filenames
    photo: [...photoItems, ...freeFlowPhotoEntries],
    visa_fees: [...visaFeesRows].map((row, index) => ({
      row_type: row.type,
      tourist: row.tourist || '',
      transit: row.transit || '',
      business: row.business || '',
      tourist_charges: row.tourist_charges || '',
      transit_charges: row.transit_charges || '',
      business_charges: row.business_charges || '',
      row_order: index
    })),
    submission: submissionRows.map((row, index) => ({
      label: row.label,
      tourist: row.tourist,
      transit: row.transit,
      business: row.business,
      row_order: index
    })),
    tourist_visa_remarks: touristVisaRemarks
  };
  
        // FIXED: also save when fees / submission / remarks / free-flow photos exist (same as Group tour)
        if (touristVisaItems.length > 0 || transitVisaItems.length > 0 || businessVisaItems.length > 0 || photoItems.length > 0 ||
            freeFlowPhotoEntries.length > 0 || visaFeesRows.length > 0 || submissionRows.length > 0 || touristVisaRemarks) {
          await fetch(`${baseurl}/api/visa/bulk`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ tour_id: id, ...visaData })
          });
        }
      // Transport
      if (transports.length > 0) {
        await fetch(`${baseurl}/api/tour-transports/bulk`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ tour_id: id, items: transports })
        });
      }

      // Booking POI
      if (bookingPois.length > 0) {
        await fetch(`${baseurl}/api/tour-booking-poi/bulk`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ tour_id: id, items: bookingPois })
        });
      }

      // Cancellation
      if (cancelPolicies.length > 0) {
        await fetch(`${baseurl}/api/tour-cancellation/bulk`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ tour_id: id, policies: cancelPolicies })
        });
      }

      // Instructions
      if (instructions.length > 0) {
        await fetch(`${baseurl}/api/tour-instructions/bulk`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ tour_id: id, items: instructions })
        });
      }

      // Exclusions
      if (exclusions.length > 0) {
        await fetch(`${baseurl}/api/exclusions/bulk`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ tour_id: id, items: exclusions })
        });
      }

      // Inclusions
      if (inclusions.length > 0) {
        await fetch(`${baseurl}/api/inclusions/bulk`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ tour_id: id, items: inclusions })
        });
      }

      // Itineraries
      if (itineraries.length > 0) {
        const itineraryPayload = itineraries.map((item) => ({
          ...item,
          tour_id: id
        }));

        await fetch(`${baseurl}/api/itineraries/bulk`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(itineraryPayload)
        });
      }

      // Images (only if new files added)
      if (imageFiles.length > 0) {
        const formDataImages = new FormData();
        imageFiles.forEach((file) => {
          formDataImages.append('images', file);
        });

        if (imageCaption.trim()) {
          formDataImages.append('caption', imageCaption.trim());
        }

        await fetch(`${baseurl}/api/images/upload/${id}`, {
          method: 'POST',
          body: formDataImages
        });
      }

      setSuccess('Tour updated successfully!');
      setTimeout(() => navigate('/intl-senior-citizen-tours'), 1500);
    } catch (err) {
      console.error('Error updating tour:', err);
      setError(err.message || 'Failed to update tour');
    } finally {
      setLoading(false);
    }
  };
  const createTour = async () => {
    if (!formData.tour_code.trim()) {
      setError('Tour code is required');
      setActiveTab('basic');
      return;
    }
    if (!formData.title.trim()) {
      setError('Tour title is required');
      setActiveTab('basic');
      return;
    }

    try {
      setLoading(true);
      setError('');
      setSuccess('');

      // 1) CREATE TOUR
      const tourRes = await fetch(`${baseurl}/api/tours`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
    ...formData,
      country_id: formData.country_id, // Add this
    optional_tour_remarks: formData.optional_tour_remarks || '', // ← ADD THIS LINE
    departure_remarks: formData.departure_remarks || '',         // NEW
    instruction_remarks: formData.instruction_remarks || ''      // NEW
  })
      });

      if (!tourRes.ok) {
        const err = await tourRes.json().catch(() => ({}));
        throw new Error(err.error || 'Failed to create tour');
      }

      const tourData = await tourRes.json();
      const tourId = tourData.tour_id || tourData.id || tourData.insertId;
    const uploadedVisaForms = await uploadVisaFormFiles(tourId, visaFormItems);

      // 2) DEPARTURES BULK - UPDATED WITH HOTEL PRICE FIELDS
      if (departures.length > 0) {
        const formattedDepartures = departures.map(dept => ({
          tour_type: 'Group',
          start_date: dept.start_date,
          end_date: dept.end_date,
          status: dept.status,
          total_seats: dept.total_seats || 40,
          booked_seats: dept.booked_seats || 0,
          description: dept.description || null,
          adult_price: dept.three_star_twin || 0,
          // 3-Star Hotel Prices
          three_star_twin: dept.three_star_twin || null,
          three_star_triple: dept.three_star_triple || null,
          three_star_child_with_bed: dept.three_star_child_with_bed || null,
          three_star_child_without_bed: dept.three_star_child_without_bed || null,
          three_star_infant: dept.three_star_infant || null,
          three_star_single: dept.three_star_single || null,
          // 4-Star Hotel Prices
          four_star_twin: dept.four_star_twin || null,
          four_star_triple: dept.four_star_triple || null,
          four_star_child_with_bed: dept.four_star_child_with_bed || null,
          four_star_child_without_bed: dept.four_star_child_without_bed || null,
          four_star_infant: dept.four_star_infant || null,
          four_star_single: dept.four_star_single || null,
          // 5-Star Hotel Prices
          five_star_twin: dept.five_star_twin || null,
          five_star_triple: dept.five_star_triple || null,
          five_star_child_with_bed: dept.five_star_child_with_bed || null,
          five_star_child_without_bed: dept.five_star_child_without_bed || null,
          five_star_infant: dept.five_star_infant || null,
          five_star_single: dept.five_star_single || null
        }));

        await fetch(`${baseurl}/api/departures/bulk`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ tour_id: tourId, departures: formattedDepartures })
        });
      }

      // 3) EXCLUSIONS
      if (exclusions.length > 0) {
        await fetch(`${baseurl}/api/exclusions/bulk`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ tour_id: tourId, items: exclusions })
        });
      }

      // 4) IMAGES
      if (imageFiles.length > 0) {
        const formDataImages = new FormData();
        imageFiles.forEach((file) => {
          formDataImages.append('images', file);
        });
        if (imageCaption.trim()) {
          formDataImages.append('caption', imageCaption.trim());
        }
        await fetch(`${baseurl}/api/images/upload/${tourId}`, {
          method: 'POST',
          body: formDataImages
        });
      }

      // 5) INCLUSIONS
      if (inclusions.length > 0) {
        await fetch(`${baseurl}/api/inclusions/bulk`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ tour_id: tourId, items: inclusions })
        });
      }

      // 6) ITINERARY DAYS
      if (itineraries.length > 0) {
        const payload = itineraries.map((item) => ({
          ...item,
          tour_id: tourId
        }));
        await fetch(`${baseurl}/api/itineraries/bulk`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
      }

      // 7) OPTIONAL TOURS BULK
      if (optionalTours.length > 0) {
        await fetch(`${baseurl}/api/optional-tours/bulk`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ tour_id: tourId, optional_tours: optionalTours })
        });
      }

      // 8) EMI OPTIONS BULK
     // 6) EMI OPTIONS - UPDATED
if (emiLoanAmount && !isNaN(emiLoanAmount) && emiLoanAmount > 0) {
  // Use the global loan amount
  await fetch(`${baseurl}/api/emi-options/emi/bulk`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ 
      tour_id: tourId, 
      loan_amount: emiLoanAmount 
      // Remove the emi_options array from here
      // The backend will generate all options based on loan_amount
    })
  });
} else {
  // Fallback to existing behavior if no global loan amount
  const validEmiOptions = emiOptions.filter(opt =>
    opt.loan_amount && opt.loan_amount > 0 && opt.emi && opt.emi > 0
  );
  if (validEmiOptions.length > 0) {
    await fetch(`${baseurl}/api/emi-options/emi/bulk`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ 
        tour_id: tourId, 
        emi_options: validEmiOptions 
      })
    });
  }
}

      // 9) HOTELS BULK
      if (hotelRows.length > 0) {
        await fetch(`${baseurl}/api/tour-hotels/bulk`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ tour_id: tourId, hotels: hotelRows })
        });
      }


  // In createTour and updateTour functions, update the visaData preparation:
const visaData = {
  tourist_visa: touristVisaItems,
  transit_visa: transitVisaItems,
  business_visa: businessVisaItems,
   visa_forms: uploadedVisaForms.map(form => ({
    type: form.type,
    download_text: form.download_text,
    download_action: form.download_action,
    fill_action: form.fill_action,
    action1_file: form.action1_file, // Filename string
    action2_file: form.action2_file  // Filename string
  })),
  photo: [...photoItems, ...freeFlowPhotoEntries],
   visa_fees: [...visaFeesRows].map((row, index) => ({
    row_type: row.type,
    tourist: row.tourist || '',
    transit: row.transit || '',
    business: row.business || '',
    tourist_charges: row.tourist_charges || '',
    transit_charges: row.transit_charges || '',
    business_charges: row.business_charges || '',
    row_order: index
  })),
  submission: submissionRows.map((row, index) => ({
    label: row.label,
    tourist: row.tourist,
    transit: row.transit,
    business: row.business,
    row_order: index
  })),
  tourist_visa_remarks: touristVisaRemarks
};

          // FIXED: also save when fees / submission / remarks / free-flow photos exist (same as Group tour)
          if (touristVisaItems.length > 0 || transitVisaItems.length > 0 || businessVisaItems.length > 0 || photoItems.length > 0 ||
              freeFlowPhotoEntries.length > 0 || visaFeesRows.length > 0 || submissionRows.length > 0 || touristVisaRemarks) {
            await fetch(`${baseurl}/api/visa/bulk`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ tour_id: tourId, ...visaData })
            });
          }
      // 10) TRANSPORT BULK
      if (transports.length > 0) {
        await fetch(`${baseurl}/api/tour-transports/bulk`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ tour_id: tourId, items: transports })
        });
      }

      // 11) BOOKING POI BULK
      if (bookingPois.length > 0) {
        await fetch(`${baseurl}/api/tour-booking-poi/bulk`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ tour_id: tourId, items: bookingPois })
        });
      }

      // 12) CANCELLATION BULK
      if (cancelPolicies.length > 0) {
        await fetch(`${baseurl}/api/tour-cancellation/bulk`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ tour_id: tourId, policies: cancelPolicies })
        });
      }

      // 13) INSTRUCTIONS BULK
      if (instructions.length > 0) {
        await fetch(`${baseurl}/api/tour-instructions/bulk`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ tour_id: tourId, items: instructions })
        });
      }

      setSuccess('Tour saved successfully!');
      setTimeout(() => navigate('/intl-senior-citizen-tours'), 1500);
    } catch (err) {
      setError(err.message || 'Failed to save tour');
    } finally {
      setLoading(false);
    }
  };
    const uploadVisaFormFiles = async (tourId, visaForms) => {
  const uploadedForms = [];

  for (const form of visaForms) {
    const formData = {
      type: form.type,
      download_text: form.download_text,
      download_action: form.download_action,
      fill_action: form.fill_action,
      action1_file: null,
      action2_file: null
    };

    // Upload action1_file (PDF) if exists
    if (form.action1_file && typeof form.action1_file === 'object') {
      const fileName = await handleVisaFormFileUpload(tourId, form.type, 'action1', form.action1_file);
      if (fileName) {
        formData.action1_file = fileName;
      }
    } else if (form.action1_file && typeof form.action1_file === 'string') {
      // Already a filename (from editing)
      formData.action1_file = form.action1_file;
    }

    // Upload action2_file (Word) if exists
    if (form.action2_file && typeof form.action2_file === 'object') {
      const fileName = await handleVisaFormFileUpload(tourId, form.type, 'action2', form.action2_file);
      if (fileName) {
        formData.action2_file = fileName;
      }
    } else if (form.action2_file && typeof form.action2_file === 'string') {
      // Already a filename (from editing)
      formData.action2_file = form.action2_file;
    }

    uploadedForms.push(formData);
  }

  return uploadedForms;
};

const handleSaveClick = () => {
  if (isLastTab) {
    if (isEditMode) {
      updateTour();
    } else {
      createTour();
    }
  } else {
    // Check if current visa subtab is complete before moving on
    if (activeTab === 'visa') {
      // Remove mandatory validation - visa sections can be empty
      // Simply allow navigation to next tab/subtab
      const currentSubTabIndex = visaSubTabs.indexOf(activeVisaSubTab);
      
      // If current subtab is not the last one
      if (currentSubTabIndex < visaSubTabs.length - 1) {
        // Move to next visa subtab
        setActiveVisaSubTab(visaSubTabs[currentSubTabIndex + 1]);
      } else {
        // All visa subtabs are done, move to booking
        const currentIndex = TAB_LIST.indexOf(activeTab);
        if (currentIndex < TAB_LIST.length - 1) {
          setActiveTab(TAB_LIST[currentIndex + 1]); // Move to bookingPoi
        }
      }
      return;
    }
    
    goNext();
  }
};

  // Dynamic "+ Add ..." button for bottom bar
    // Dynamic "+ Add ..." button for bottom bar
   const getAddConfigForTab = (tabKey) => {
    switch (tabKey) {
      case 'itineraries':
       return { 
        label: editingItineraryIndex !== -1 ? '✓ Update Itinerary' : '+ Add Day', 
        onClick: handleAddItinerary 
      };
      case 'departures':
       return { 
        label: editingDepartureIndex !== -1 ? '✓ Update Departure' : '+ Add Departure', 
        onClick: handleAddDeparture 
      };
       case 'optionalTours':
       return { 
        label: editingOptionalTourIndex !== -1 ? '✓ Update Optional Tour' : '+ Add Optional Tour', 
        onClick: addOptionalTourRow 
      };
      case 'inclusions':
        return { 
        label: editingInclusionIndex !== -1 ? '✓ Update Inclusion' : '+ Add Inclusion', 
        onClick: handleAddInclusion 
      };
      case 'exclusions':
        return { 
        label: editingExclusionIndex !== -1 ? '✓ Update Exclusion' : '+ Add Exclusion', 
        onClick: handleAddExclusion 
      };
      case 'transport':
         return { 
        label: editingTransportIndex !== -1 ? '✓ Update Transport' : '+ Add Transport', 
        onClick: addTransportRow 
      };
      case 'hotels':
        return { 
        label: editingHotelIndex !== -1 ? '✓ Update Hotel' : '+ Add Hotel', 
        onClick: addHotelRow 
      };
      case 'visa':
          // Check which subtab is active
          if (activeVisaSubTab === 'tourist') {
            return { 
              label: editingType === 'touristVisa' ? 'Update Tourist Visa' : '+ Add Tourist Visa', 
              onClick: addTouristVisa 
            };
          } else if (activeVisaSubTab === 'transit') {
            return { 
              label: editingType === 'transitVisa' ? 'Update Transit Visa' : '+ Add Transit Visa', 
              onClick: addTransitVisa 
            };
          } else if (activeVisaSubTab === 'business') {
            return { 
              label: editingType === 'businessVisa' ? 'Update Business Visa' : '+ Add Business Visa', 
              onClick: addBusinessVisa 
            };
          } else if (activeVisaSubTab === 'photo') {
            return { 
              label: editingType === 'photo' ? 'Update Photo' : '+ Add Photo', 
              onClick: addPhoto 
            };
          } else if (activeVisaSubTab === 'form') {
            if (editingVisaFormIndex !== null) {
              return {
                label: 'Update Visa Form',
                onClick: updateVisaFormItem
              };
            }
          }
          return null;

      case 'bookingPoi':
        return { 
          label: editingBookingPoiIndex  !== -1  ? '✓ Update Booking Policy' : '+ Add Booking Policy', 
          onClick: addPoi 
        };
      case 'cancellation':
        return { 
          label: editingCancellationIndex  !== -1 ? '✓ Update Cancellation Policy' : '+ Add Cancellation Policy', 
          onClick: addCancelRow 
        };
      // REMOVED the 'instructions' case to hide the "+ Add Instruction" button
      // case 'instructions':
      //   return { 
      //     label: editingInstructionIndex  !== -1 ? '✓ Update Instruction' : '+ Add Instruction', 
      //     onClick: addInstruction 
      //   };

      default:
        return null;
    }
  };
  
  const addConfig = getAddConfigForTab(activeTab);

  return (
    <Navbar>
      <Container>
        <h2 className="mb-4">{isEditMode ? 'Edit Senior Citizen Tour' : 'Add Senior Citizen Tour'}</h2>

        {error && <Alert variant="danger">{error}</Alert>}
        {success && <Alert variant="success">{success}</Alert>}


          {/* ======== BUTTONS ======== */}
            <div className="d-flex justify-content-end gap-2 mt-4 mb-4">
              <Button
                variant="secondary"
                onClick={handleCancel}
                disabled={loading}
              >
                Cancel
              </Button>

              <Button
                variant="secondary"
                onClick={goBack}
                disabled={activeTab === 'basic' || loading}
              >
                Back
              </Button>

              {addConfig && (
                <Button
                  variant="success"
                  onClick={addConfig.onClick}
                  disabled={loading}
                >
                  {addConfig.label}
                </Button>
              )}

             {/* Update the Save & Continue button text in visa tab */}
                  <Button
                    variant="primary"
                    onClick={handleSaveClick}
                    disabled={loading}
                  >
                    {loading ? 'Saving...' : 
                    isLastTab ? (isEditMode ? 'Update All' : 'Save All') : 
                    activeTab === 'visa' ? `Save & Next (${visaSubTabs.indexOf(activeVisaSubTab) + 1}/${visaSubTabs.length})` : 
                    'Save & Continue'}
                  </Button>
            </div>

        <Card>
          <Card.Body>
            <Tabs
              activeKey={activeTab}
              onSelect={(k) => setActiveTab(k)}
              className="mb-4"
            >
              {/* ======== TAB 1: BASIC DETAILS ======== */}
              <Tab eventKey="basic" title="Basic Details">
                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Tour Code *</Form.Label>
                      <Form.Control
                        type="text"
                        name="tour_code"
                        value={formData.tour_code}
                        onChange={handleBasicChange}
                        readOnly
                        disabled={isEditMode}
                        style={{
                          cursor: isEditMode ? "not-allowed" : "default",
                          fontWeight: "bold",
                          backgroundColor: isEditMode ? "#f8f9fa" : "white"
                        }}
                      />
                      {/* <Form.Text className="text-muted">
                        {isEditMode ? "Tour code cannot be changed" : "Auto-generated tour code"}
                      </Form.Text> */}
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label>Tour Title *</Form.Label>
                      <Form.Control
                        type="text"
                        name="title"
                        value={formData.title}
                        onChange={handleBasicChange}
                      />
                    </Form.Group>

                    {/* <Form.Group className="mb-3">
                      <Form.Label>International Tour?</Form.Label>
                      <Form.Select
                        name="is_international"
                        value={formData.is_international}
                        onChange={handleBasicChange}
                      >
                        <option value={0}>No</option>
                        <option value={1}>Yes</option>
                      </Form.Select>
                    </Form.Group> */}

                    <Form.Group className="mb-3">
                      <Form.Label>Tour Price *</Form.Label>
                      <Form.Control
                        type="number"
                        name="base_price_adult"
                        value={formData.base_price_adult}
                        onChange={handleBasicChange}
                      />
                    </Form.Group>
                    
                  </Col>

                  <Col md={6}>
                 <Form.Group className="mb-3">
  <Form.Label>International Destinations *</Form.Label>
  <Form.Select
    name="primary_destination_id"
    value={formData.primary_destination_id}
    onChange={(e) => {
      const selectedId = e.target.value;
      const selectedDestination = destinations.find(d => d.destination_id == selectedId);
      
      // Update both destination_id and country_id
      setFormData(prev => ({
        ...prev,
        primary_destination_id: selectedId,
        country_id: selectedDestination ? selectedDestination.country_id : ''
      }));
    }}
  >
    <option value="">Select Destination</option>
    {destinations.map((d) => (
      <option
        key={d.destination_id}
        value={d.destination_id}
      >
        {d.name} ({d.country_name})
      </option>
    ))}
  </Form.Select>
</Form.Group>
                    <Form.Group className="mb-3">
                      <Form.Label>Duration Days *</Form.Label>
                      <Form.Control
                        type="number"
                        name="duration_days"
                        value={formData.duration_days}
                        onChange={handleBasicChange}
                      />
                    </Form.Group>


                     <Form.Group className="mb-3">
                        <Form.Label>EMI Price</Form.Label>
                        <Form.Control
                          type="number"
                          name="emi_price"
                          value={formData.emi_price}
                          onChange={handleBasicChange}
                          placeholder="Optional EMI price"
                        />
                        {/* <Form.Text className="text-muted">
                          This is the price used for EMI calculations (if different from tour price)
                        </Form.Text> */}
                    </Form.Group>


                  </Col>
                </Row>
              </Tab>

              <Tab eventKey="itineraries" title="Itineraries">
                <Row>
                  <Col md={2}>
                    <Form.Group className="mb-3">
                      <Form.Label>Day</Form.Label>
                      <Form.Control
                        type="number"
                        name="day"
                        value={itineraryItem.day}
                        onChange={handleItineraryChange}
                      />
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group className="mb-3">
                      <Form.Label>Title</Form.Label>
                      <Form.Control
                        type="text"
                        name="title"
                        value={itineraryItem.title}
                        onChange={handleItineraryChange}
                      />
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Meals</Form.Label>
                      <div className="d-flex gap-3">
                        <Form.Check
                          type="checkbox"
                          label="Breakfast"
                          name="breakfast"
                          checked={itineraryItem.meals.breakfast}
                          onChange={handleMealsCheckboxChange}
                        />
                        <Form.Check
                          type="checkbox"
                          label="Lunch"
                          name="lunch"
                          checked={itineraryItem.meals.lunch}
                          onChange={handleMealsCheckboxChange}
                        />
                        <Form.Check
                          type="checkbox"
                          label="Dinner"
                          name="dinner"
                          checked={itineraryItem.meals.dinner}
                          onChange={handleMealsCheckboxChange}
                        />
                      </div>
                    </Form.Group>
                  </Col>
                </Row>

                <Form.Group className="mb-3">
                  <Form.Label>Description</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    name="description"
                    value={itineraryItem.description}
                    onChange={handleItineraryChange}
                  />
                </Form.Group>

                {itineraries.length > 0 && (
                  <Table striped bordered hover size="sm" className="mt-3">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Day</th>
                        <th>Title</th>
                        <th>Meals</th>
                        <th>Description</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {itineraries
                        .sort((a, b) => a.day - b.day)
                        .map((item, idx) => (
                          <tr key={idx}>
                            <td>{idx + 1}</td>
                            <td>{item.day}</td>
                            <td>{item.title}</td>
                            <td>{item.meals || '-'}</td>
                            <td>{item.description || '-'}</td>
                            <td>
                              <div className="d-flex gap-1">
                                <Button
                                  variant="outline-warning"
                                  size="sm"
                                  onClick={() => editItinerary(idx)}
                                  title="Edit"
                                >
                                  <Pencil size={14} />
                                </Button>
                                <Button
                                  variant="outline-danger"
                                  size="sm"
                                  onClick={() => handleRemoveItinerary(idx)}
                                  title="Remove"
                                >
                                  <Trash size={14} />
                                </Button>
                              </div>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </Table>
                )}
              </Tab>

              {/* ======== DEPARTURES TAB - SENIOR CITIZEN TOUR (UPDATED) ======== */}
              <Tab eventKey="departures" title="Departures & Costs">
                                          <div>
                                            {/* Departure Dates Section */}
                                            <Row className="mb-4">
                                              <h5>Add Departure with Costs</h5>
                                              <Col md={3}>
                                                <Form.Group className="mb-3">
                                                  <Form.Label>Start Date *</Form.Label>
                                                  <Form.Control
                                                    type="date"
                                                    name="start_date"
                                                    value={seniorDepartureForm.start_date}
                                                    onChange={handleGroupDepartureChange}
                                                  />
                                                </Form.Group>
                                              </Col>
                                        
                                              <Col md={3}>
                                                <Form.Group className="mb-3">
                                                  <Form.Label>End Date *</Form.Label>
                                                  <Form.Control
                                                    type="date"
                                                    name="end_date"
                                                    value={seniorDepartureForm.end_date}
                                                    onChange={handleGroupDepartureChange}
                                                  />
                                                </Form.Group>
                                              </Col>
                                        
                                              <Col md={2}>
                                                <Form.Group className="mb-3">
                                                  <Form.Label>Status *</Form.Label>
                                                  <Form.Select
                                                    name="status"
                                                    value={seniorDepartureForm.status}
                                                    onChange={handleGroupDepartureChange}
                                                  >
                                                    <option value="Available">Available</option>
                                                    <option value="Few Seats">Few Seats</option>
                                                    <option value="Sold Out">Sold Out</option>
                                                    <option value="Fast Filling">Fast Filling</option>
                                                  </Form.Select>
                                                </Form.Group>
                                              </Col>
                                        
                                              <Col md={2}>
                                                <Form.Group className="mb-3">
                                                  <Form.Label>Total Seats</Form.Label>
                                                  <Form.Control
                                                    type="number"
                                                    name="total_seats"
                                                    value={seniorDepartureForm.total_seats}
                                                    onChange={handleGroupDepartureChange}
                                                    placeholder="Total seats"
                                                  />
                                                </Form.Group>
                                              </Col>
                                        
                                              <Col md={2}>
                                                <Form.Group className="mb-3">
                                                  <Form.Label>Booked Seats</Form.Label>
                                                  <Form.Control
                                                    type="number"
                                                    name="booked_seats"
                                                    value={seniorDepartureForm.booked_seats}
                                                    onChange={handleGroupDepartureChange}
                                                    placeholder="Booked seats"
                                                  />
                                                </Form.Group>
                                              </Col>
                                            </Row>
                                        
                                            {/* 3-Star Hotel Prices - Add directly in departures */}
                                            <Row className="mb-4">
                                              <h6>Standard Hotel Prices</h6>
                                              <Col md={2}>
                                                <Form.Group>
                                                  <Form.Label>Twin Sharing</Form.Label>
                                                  <Form.Control
                                                    type="number"
                                                    name="three_star_twin"
                                                    value={seniorDepartureForm.three_star_twin || ''}
                                                    onChange={handleGroupDepartureChange}
                                                    placeholder="₹"
                                                  />
                                                </Form.Group>
                                              </Col>
                                              <Col md={2}>
                                                <Form.Group>
                                                  <Form.Label>Triple Sharing</Form.Label>
                                                  <Form.Control
                                                    type="number"
                                                    name="three_star_triple"
                                                    value={seniorDepartureForm.three_star_triple || ''}
                                                    onChange={handleGroupDepartureChange}
                                                    placeholder="₹"
                                                  />
                                                </Form.Group>
                                              </Col>
                                              <Col md={2}>
                                                <Form.Group>
                                                  <Form.Label>Child With Bed</Form.Label>
                                                  <Form.Control
                                                    type="number"
                                                    name="three_star_child_with_bed"
                                                    value={seniorDepartureForm.three_star_child_with_bed || ''}
                                                    onChange={handleGroupDepartureChange}
                                                    placeholder="₹"
                                                  />
                                                </Form.Group>
                                              </Col>
                                              <Col md={2}>
                                                <Form.Group>
                                                  <Form.Label>Child No Bed</Form.Label>
                                                  <Form.Control
                                                    type="number"
                                                    name="three_star_child_without_bed"
                                                    value={seniorDepartureForm.three_star_child_without_bed || ''}
                                                    onChange={handleGroupDepartureChange}
                                                    placeholder="₹"
                                                  />
                                                </Form.Group>
                                              </Col>
                                              <Col md={2}>
                                                <Form.Group>
                                                  <Form.Label>Infant</Form.Label>
                                                  <Form.Control
                                                    type="number"
                                                    name="three_star_infant"
                                                    value={seniorDepartureForm.three_star_infant || ''}
                                                    onChange={handleGroupDepartureChange}
                                                    placeholder="₹"
                                                  />
                                                </Form.Group>
                                              </Col>
                                              <Col md={2}>
                                                <Form.Group>
                                                  <Form.Label>Single</Form.Label>
                                                  <Form.Control
                                                    type="number"
                                                    name="three_star_single"
                                                    value={seniorDepartureForm.three_star_single || ''}
                                                    onChange={handleGroupDepartureChange}
                                                    placeholder="₹"
                                                  />
                                                </Form.Group>
                                              </Col>
                                            </Row>
                                        
                                            {/* 4-Star Hotel Prices */}
                                            <Row className="mb-4">
                                              <h6>Deluxe Hotel Prices</h6>
                                              <Col md={2}>
                                                <Form.Group>
                                                  <Form.Label>Twin Sharing</Form.Label>
                                                  <Form.Control
                                                    type="number"
                                                    name="four_star_twin"
                                                    value={seniorDepartureForm.four_star_twin || ''}
                                                    onChange={handleGroupDepartureChange}
                                                    placeholder="₹"
                                                  />
                                                </Form.Group>
                                              </Col>
                                              <Col md={2}>
                                                <Form.Group>
                                                  <Form.Label>Triple Sharing</Form.Label>
                                                  <Form.Control
                                                    type="number"
                                                    name="four_star_triple"
                                                    value={seniorDepartureForm.four_star_triple || ''}
                                                    onChange={handleGroupDepartureChange}
                                                    placeholder="₹"
                                                  />
                                                </Form.Group>
                                              </Col>
                                              <Col md={2}>
                                                <Form.Group>
                                                  <Form.Label>Child With Bed</Form.Label>
                                                  <Form.Control
                                                    type="number"
                                                    name="four_star_child_with_bed"
                                                    value={seniorDepartureForm.four_star_child_with_bed || ''}
                                                    onChange={handleGroupDepartureChange}
                                                    placeholder="₹"
                                                  />
                                                </Form.Group>
                                              </Col>
                                              <Col md={2}>
                                                <Form.Group>
                                                  <Form.Label>Child No Bed</Form.Label>
                                                  <Form.Control
                                                    type="number"
                                                    name="four_star_child_without_bed"
                                                    value={seniorDepartureForm.four_star_child_without_bed || ''}
                                                    onChange={handleGroupDepartureChange}
                                                    placeholder="₹"
                                                  />
                                                </Form.Group>
                                              </Col>
                                              <Col md={2}>
                                                <Form.Group>
                                                  <Form.Label>Infant</Form.Label>
                                                  <Form.Control
                                                    type="number"
                                                    name="four_star_infant"
                                                    value={seniorDepartureForm.four_star_infant || ''}
                                                    onChange={handleGroupDepartureChange}
                                                    placeholder="₹"
                                                  />
                                                </Form.Group>
                                              </Col>
                                              <Col md={2}>
                                                <Form.Group>
                                                  <Form.Label>Single</Form.Label>
                                                  <Form.Control
                                                    type="number"
                                                    name="four_star_single"
                                                    value={seniorDepartureForm.four_star_single || ''}
                                                    onChange={handleGroupDepartureChange}
                                                    placeholder="₹"
                                                  />
                                                </Form.Group>
                                              </Col>
                                            </Row>
                                        
                                            {/* 5-Star Hotel Prices */}
                                            <Row className="mb-4">
                                              <h6>Luxary Hotel Prices</h6>
                                              <Col md={2}>
                                                <Form.Group>
                                                  <Form.Label>Twin Sharing</Form.Label>
                                                  <Form.Control
                                                    type="number"
                                                    name="five_star_twin"
                                                    value={seniorDepartureForm.five_star_twin || ''}
                                                    onChange={handleGroupDepartureChange}
                                                    placeholder="₹"
                                                  />
                                                </Form.Group>
                                              </Col>
                                              <Col md={2}>
                                                <Form.Group>
                                                  <Form.Label>Triple Sharing</Form.Label>
                                                  <Form.Control
                                                    type="number"
                                                    name="five_star_triple"
                                                    value={seniorDepartureForm.five_star_triple || ''}
                                                    onChange={handleGroupDepartureChange}
                                                    placeholder="₹"
                                                  />
                                                </Form.Group>
                                              </Col>
                                              <Col md={2}>
                                                <Form.Group>
                                                  <Form.Label>Child With Bed</Form.Label>
                                                  <Form.Control
                                                    type="number"
                                                    name="five_star_child_with_bed"
                                                    value={seniorDepartureForm.five_star_child_with_bed || ''}
                                                    onChange={handleGroupDepartureChange}
                                                    placeholder="₹"
                                                  />
                                                </Form.Group>
                                              </Col>
                                              <Col md={2}>
                                                <Form.Group>
                                                  <Form.Label>Child No Bed</Form.Label>
                                                  <Form.Control
                                                    type="number"
                                                    name="five_star_child_without_bed"
                                                    value={seniorDepartureForm.five_star_child_without_bed || ''}
                                                    onChange={handleGroupDepartureChange}
                                                    placeholder="₹"
                                                  />
                                                </Form.Group>
                                              </Col>
                                              <Col md={2}>
                                                <Form.Group>
                                                  <Form.Label>Infant</Form.Label>
                                                  <Form.Control
                                                    type="number"
                                                    name="five_star_infant"
                                                    value={seniorDepartureForm.five_star_infant || ''}
                                                    onChange={handleGroupDepartureChange}
                                                    placeholder="₹"
                                                  />
                                                </Form.Group>
                                              </Col>
                                              <Col md={2}>
                                                <Form.Group>
                                                  <Form.Label>Single</Form.Label>
                                                  <Form.Control
                                                    type="number"
                                                    name="five_star_single"
                                                    value={seniorDepartureForm.five_star_single || ''}
                                                    onChange={handleGroupDepartureChange}
                                                    placeholder="₹"
                                                  />
                                                </Form.Group>
                                              </Col>
                                            </Row>
                                          </div>
                                        
                                        
                                          {/* Departure Description Section (NEW - bound to departure_remarks) */}
                                        {/* <Form.Group className="mt-4">
                                          <Form.Label>Departure Description</Form.Label>
                                          <Form.Control
                                            as="textarea"
                                            rows={3}
                                            name="departure_remarks"
                                            value={formData.departure_remarks || ''}
                                            onChange={handleBasicChange}
                                            placeholder="Enter departure description here..."
                                          />
                                        </Form.Group> */}

                                          {/* Cost Remarks Section */}
                                        <Form.Group className="mt-4">
                                          <Form.Label>Cost Remarks</Form.Label>
                                          <Form.Control
                                            as="textarea"
                                            rows={3}
                                            name="cost_remarks"
                                            value={formData.cost_remarks}
                                            onChange={handleBasicChange}
                                            placeholder="Enter cost remarks here..."
                                          />
                                        </Form.Group>
                                        
                                          {/* Display Added Departures with Costs */}
                                          {departures.length > 0 && (
                                            <div className="mt-4">
                                              <h5>Added Departures</h5>
                                              <Table striped bordered hover size="sm">
                                                <thead>
                                                  <tr>
                                                    <th>#</th>
                                                    <th>Start Date</th>
                                                    <th>End Date</th>
                                                    <th>Status</th>
                                                    <th>Seats</th>
                                                    <th>3-Star Twin</th>
                                                    <th>4-Star Twin</th>
                                                    <th>5-Star Twin</th>
                                                    <th>Action</th>
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  {departures.map((dep, idx) => (
                                                    <tr key={idx}>
                                                      <td>{idx + 1}</td>
                                                      <td>{dep.start_date || '-'}</td>
                                                      <td>{dep.end_date || '-'}</td>
                                                      <td>{dep.status || '-'}</td>
                                                      <td>{dep.total_seats || '-'}</td>
                                                      <td>{dep.three_star_twin ? `₹${dep.three_star_twin.toLocaleString()}` : '-'}</td>
                                                      <td>{dep.four_star_twin ? `₹${dep.four_star_twin.toLocaleString()}` : '-'}</td>
                                                      <td>{dep.five_star_twin ? `₹${dep.five_star_twin.toLocaleString()}` : '-'}</td>
                                                      <td>
                                                        <div className="d-flex gap-1">
                                                          <Button
                                                            variant="outline-warning"
                                                            size="sm"
                                                            onClick={() => editDeparture(idx)}
                                                            title="Edit"
                                                          >
                                                            <Pencil size={14} />
                                                          </Button>
                                                          <Button
                                                            variant="outline-danger"
                                                            size="sm"
                                                            onClick={() => handleRemoveDeparture(idx)}
                                                            title="Remove"
                                                          >
                                                            <Trash size={14} />
                                                          </Button>
                                                        </div>
                                                      </td>
                                                    </tr>
                                                  ))}
                                                </tbody>
                                              </Table>
                                            </div>
                                          )}

                                          {/* Add cancel button when editing (same as Group tour) */}
                                          {editingDepartureIndex !== -1 && (
                                            <Button
                                              variant="outline-secondary"
                                              onClick={() => {
                                                setEditingDepartureIndex(-1);
                                                // Reset only dates, keep cost values from the departure being edited
                                                const currentForm = { ...seniorDepartureForm };
                                                setSeniorDepartureForm({
                                                  start_date: '',
                                                  end_date: '',
                                                  status: currentForm.status || 'Available',
                                                  total_seats: currentForm.total_seats || 40,
                                                  booked_seats: 0,
                                                  description: currentForm.description || '',
                                                  three_star_twin: currentForm.three_star_twin || '',
                                                  three_star_triple: currentForm.three_star_triple || '',
                                                  three_star_child_with_bed: currentForm.three_star_child_with_bed || '',
                                                  three_star_child_without_bed: currentForm.three_star_child_without_bed || '',
                                                  three_star_infant: currentForm.three_star_infant || '',
                                                  three_star_single: currentForm.three_star_single || '',
                                                  four_star_twin: currentForm.four_star_twin || '',
                                                  four_star_triple: currentForm.four_star_triple || '',
                                                  four_star_child_with_bed: currentForm.four_star_child_with_bed || '',
                                                  four_star_child_without_bed: currentForm.four_star_child_without_bed || '',
                                                  four_star_infant: currentForm.four_star_infant || '',
                                                  four_star_single: currentForm.four_star_single || '',
                                                  five_star_twin: currentForm.five_star_twin || '',
                                                  five_star_triple: currentForm.five_star_triple || '',
                                                  five_star_child_with_bed: currentForm.five_star_child_with_bed || '',
                                                  five_star_child_without_bed: currentForm.five_star_child_without_bed || '',
                                                  five_star_infant: currentForm.five_star_infant || '',
                                                  five_star_single: currentForm.five_star_single || ''
                                                });
                                              }}
                                              className="ms-2"
                                            >
                                              Cancel Edit
                                            </Button>
                                          )}
                                        
                                </Tab>

              {/* ======== OPTIONAL TOURS ======== */}
              <Tab eventKey="optionalTours" title="Optional Tour">
                <Row className="align-items-end">
                  <Col md={4}>
                    <Form.Group>
                      <Form.Label>Tour Name *</Form.Label>
                      <Form.Control
                        type="text"
                        name="tour_name"
                        value={optionalTourItem.tour_name}
                        onChange={handleOptionalTourChange}
                        placeholder="Enter optional tour name"
                      />
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group>
                      <Form.Label>Adult Price</Form.Label>
                      <Form.Control
                        type="text"
                        name="adult_price"
                        value={optionalTourItem.adult_price}
                        onChange={handleOptionalTourChange}
                        placeholder="Enter adult price"
                      />
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group>
                      <Form.Label>Child Price</Form.Label>
                      <Form.Control
                        type="text"
                        name="child_price"
                        value={optionalTourItem.child_price}
                        onChange={handleOptionalTourChange}
                        placeholder="Enter child price"
                      />
                    </Form.Group>
                  </Col>
                </Row>

                 {/* ADD THIS FORM GROUP FOR OPTIONAL TOUR REMARKS */}
  <Form.Group className="mt-3">
    <Form.Label>Optional Tour Remarks</Form.Label>
    <Form.Control
      as="textarea"
      rows={3}
      name="optional_tour_remarks"
      value={formData.optional_tour_remarks || ''}
      onChange={handleBasicChange}
      placeholder="Enter any remarks for optional tours..."
    />
  </Form.Group>

                {optionalTours.length > 0 && (
                  <Table striped bordered hover size="sm" className="mt-3">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Tour Name</th>
                        <th>Adult Price</th>
                        <th>Child Price</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {optionalTours.map((tour, idx) => (
                        <tr key={idx}>
                          <td>{idx + 1}</td>
                          <td>{tour.tour_name}</td>
                          <td>{tour.adult_price || 'NA'}</td>
                          <td>{tour.child_price || 'NA'}</td>
                          <td>
                            <div className="d-flex gap-1">
                              <Button
                                variant="outline-warning"
                                size="sm"
                                onClick={() => editOptionalTourRow(idx)}
                                title="Edit"
                              >
                                <Pencil size={14} />
                              </Button>
                              <Button
                                variant="outline-danger"
                                size="sm"
                                onClick={() => removeOptionalTourRow(idx)}
                                title="Remove"
                              >
                                <Trash size={14} />
                              </Button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                )}
              </Tab>

              {/* ======== EMI OPTIONS (MANUAL) ======== */}
              <Tab eventKey="emiOptions" title="EMI Options">
  <Card className="mb-4">
    {/* <Card.Header>EMI Calculator</Card.Header> */}
    <Card.Body>
      <Row>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Loan Amount *</Form.Label>
            <InputGroup>
              <InputGroup.Text>₹</InputGroup.Text>
              <Form.Control
                type="number"
                min="0"
                step="1000"
                value={emiLoanAmount}
                onChange={(e) => handleLoanAmountChange(e.target.value)}
                placeholder="Enter loan amount"
              />
            </InputGroup>
            {/* <Form.Text className="text-muted">
              This amount will be used for all EMI calculations
            </Form.Text> */}
          </Form.Group>
        </Col>
        
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Interest Rate (%) *</Form.Label>
            <InputGroup>
              <InputGroup.Text>%</InputGroup.Text>
              <Form.Control
                type="number"
                min="0"
                max="50"
                step="0.1"
                value={emiInterestRate}
                onChange={(e) => setEmiInterestRate(e.target.value)}
              />
            </InputGroup>
            {/* <Form.Text className="text-muted">
              Annual interest rate for EMI calculation
            </Form.Text> */}
          </Form.Group>
        </Col>
      </Row>
      
      {/* {emiLoanAmount && emiLoanAmount > 0 && (
        <Alert variant="info" className="mt-3">
          <strong>Note:</strong> EMI values are automatically calculated based on the loan amount 
          and interest rate. All EMI options will use the same loan amount of ₹{emiLoanAmount} 
          with {emiInterestRate}% annual interest rate.
        </Alert>
      )} */}
    </Card.Body>
  </Card>

  <Table striped bordered hover responsive className="align-middle">
    <thead className="table-dark">
      <tr>
        <th width="5%">#</th>
        <th width="30%">Particulars</th>
        <th width="25%">Loan Amount</th>
        <th width="15%">Months</th>
        <th width="25%">EMI (Calculated)</th>
      </tr>
    </thead>
    <tbody>
      {emiOptions.map((option, index) => (
        <tr key={index}>
          <td className="text-center">{index + 1}</td>
          <td>
            <Form.Control
              type="text"
              value={option.particulars}
              readOnly
              plaintext
              className="border-0 bg-transparent"
            />
          </td>
          <td>
            <Form.Group className="mb-0">
              <InputGroup>
                <InputGroup.Text>₹</InputGroup.Text>
                <Form.Control
                  type="number"
                  min="0"
                  step="1000"
                  value={option.loan_amount || ''}
                  onChange={(e) => {
                    // If you want to allow individual editing, keep this
                    // Otherwise, make it read-only
                    const updatedOptions = [...emiOptions];
                    updatedOptions[index].loan_amount = e.target.value;
                    updatedOptions[index].emi = calculateEMI(
                      e.target.value, 
                      option.months, 
                      emiInterestRate
                    );
                    setEmiOptions(updatedOptions);
                  }}
                  placeholder="Enter amount"
                  readOnly={!!emiLoanAmount} // Make read-only if global loan amount is set
                />
              </InputGroup>
            </Form.Group>
          </td>
          <td className="text-center">
            <Form.Control
              type="text"
              value={option.months}
              readOnly
              plaintext
              className="border-0 bg-transparent text-center"
            />
          </td>
          <td>
            <Form.Group className="mb-0">
              <InputGroup>
                <InputGroup.Text>₹</InputGroup.Text>
                <Form.Control
                  type="number"
                  min="0"
                  step="100"
                  value={option.emi || ''}
                  readOnly
                  className="bg-light"
                  style={{ fontWeight: 'bold' }}
                />
              </InputGroup>
            </Form.Group>
            {/* <small className="text-muted">
              Monthly payment for {option.months} months
            </small> */}
          </td>
        </tr>
      ))}
    </tbody>
  </Table>

  <Form.Group className="mt-4">
    <Form.Label>EMI Remarks</Form.Label>
    <Form.Control
      as="textarea"
      rows={3}
      name="emi_remarks"
      value={formData.emi_remarks}
      onChange={handleBasicChange}
      placeholder="Enter any EMI-related remarks or notes..."
    />
  </Form.Group>
</Tab>

              <Tab eventKey="inclusions" title="Inclusions">
                <Form.Group className="mb-3">
                  <Form.Label>Inclusions</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    value={inclusionText}
                    onChange={(e) => setInclusionText(e.target.value)}
                    placeholder="Type an inclusion"
                  />
                </Form.Group>

                {inclusions.length > 0 && (
                  <Table striped bordered hover size="sm">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Inclusion</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {inclusions.map((item, idx) => (
                        <tr key={idx}>
                          <td>{idx + 1}</td>
                          <td>{item}</td>
                          <td>
                            <div className="d-flex gap-1">
                              <Button
                                variant="outline-warning"
                                size="sm"
                                onClick={() => editInclusion(idx)}
                                title="Edit"
                              >
                                <Pencil size={14} />
                              </Button>
                              <Button
                                variant="outline-danger"
                                size="sm"
                                onClick={() => handleRemoveInclusion(idx)}
                                title="Remove"
                              >
                                <Trash size={14} />
                              </Button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                )}
              </Tab>

              <Tab eventKey="exclusions" title="Exclusions">
                <Form.Group className="mb-3">
                  <Form.Label>Exclusions</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    value={exclusionText}
                    onChange={(e) => setExclusionText(e.target.value)}
                    placeholder="Type an exclusion"
                  />
                </Form.Group>

                {exclusions.length > 0 && (
                  <Table striped bordered hover size="sm">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Exclusion</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {exclusions.map((item, idx) => (
                        <tr key={idx}>
                          <td>{idx + 1}</td>
                          <td>{item}</td>
                          <td>
                            <div className="d-flex gap-1">
                              <Button
                                variant="outline-warning"
                                size="sm"
                                onClick={() => editExclusion(idx)}
                                title="Edit"
                              >
                                <Pencil size={14} />
                              </Button>
                              <Button
                                variant="outline-danger"
                                size="sm"
                                onClick={() => handleRemoveExclusion(idx)}
                                title="Remove"
                              >
                                <Trash size={14} />
                              </Button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                )}
              </Tab>

              {/* ======== TRANSPORT TAB - SENIOR CITIZEN TOUR ======== */}
              <Tab eventKey="transport" title="Flights">
                <Row className="mt-3">
                  {/* Airline */}
                  <Col md={4}>
                    <Form.Group>
                      <Form.Label>Airline</Form.Label>
                      <Form.Control
                        name="airline"
                        value={transportItem.airline}
                        onChange={handleTransportChange}
                      />
                    </Form.Group>
                  </Col>

                  {/* Flight No */}
                  <Col md={4}>
                    <Form.Group>
                      <Form.Label>Flight No</Form.Label>
                      <Form.Control
                        name="flight_no"
                        value={transportItem.flight_no}
                        onChange={handleTransportChange}
                      />
                    </Form.Group>
                  </Col>

                  {/* Via */}
                  <Col md={4}>
                    <Form.Group>
                      <Form.Label>Via</Form.Label>
                      <Form.Control
                        name="via"
                        value={transportItem.via}
                        onChange={handleTransportChange}
                      />
                    </Form.Group>
                  </Col>

                  {/* FROM */}
                  <Col md={12} className="mt-3">
                    <Form.Label className="fw-bold">From</Form.Label>
                  </Col>

                  <Col md={4}>
                    <Form.Group>
                      <Form.Label>City</Form.Label>
                      <Form.Control
                        name="from_city"
                        value={transportItem.from_city}
                        onChange={handleTransportChange}
                      />
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group>
                      <Form.Label>Date</Form.Label>
                      <Form.Control
                        type="date"
                        name="from_date"
                        value={transportItem.from_date}
                        onChange={handleTransportChange}
                      />
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group>
                      <Form.Label>Time</Form.Label>
                      <Form.Control
                        type="time"
                        name="from_time"
                        value={transportItem.from_time}
                        onChange={handleTransportChange}
                      />
                    </Form.Group>
                  </Col>

                  {/* TO */}
                  <Col md={12} className="mt-3">
                    <Form.Label className="fw-bold">To</Form.Label>
                  </Col>

                  <Col md={4}>
                    <Form.Group>
                      <Form.Label>City</Form.Label>
                      <Form.Control
                        name="to_city"
                        value={transportItem.to_city}
                        onChange={handleTransportChange}
                      />
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group>
                      <Form.Label>Date</Form.Label>
                      <Form.Control
                        type="date"
                        name="to_date"
                        value={transportItem.to_date}
                        onChange={handleTransportChange}
                      />
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group>
                      <Form.Label>Time</Form.Label>
                      <Form.Control
                        type="time"
                        name="to_time"
                        value={transportItem.to_time}
                        onChange={handleTransportChange}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                {/* ================= TRANSPORT REMARKS ================= */}
                <Form.Group className="mt-4">
                  <Form.Label>Flights Remarks</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    name="transport_remarks"
                    value={formData.transport_remarks}
                    onChange={handleBasicChange}
                  />
                </Form.Group>

                {/* ================= TABLE ================= */}
                {transports.length > 0 && (
                  <Table bordered hover size="sm" className="mt-3">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Airline</th>
                        <th>Flight</th>
                        <th>Route</th>
                        <th>Schedule</th>
                        <th>Via</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {transports.map((t, i) => (
                        <tr key={i}>
                          <td>{i + 1}</td>
                          <td>{t.airline}</td>
                          <td>{t.flight_no}</td>
                          <td>{t.from_city} → {t.to_city}</td>
                          <td>
                            {t.from_date} {t.from_time}
                            <br />
                            {t.to_date} {t.to_time}
                          </td>
                          <td>{t.via || 'Direct'}</td>
                          <td>
                            <div className="d-flex gap-1">
                              <Button
                                variant="outline-warning"
                                size="sm"
                                onClick={() => editTransportRow(i)}
                                title="Edit"
                              >
                                <Pencil size={14} />
                              </Button>
                              <Button
                                variant="outline-danger"
                                size="sm"
                                onClick={() => removeTransportRow(i)}
                                title="Remove"
                              >
                                <Trash size={14} />
                              </Button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                )}
              </Tab>

               <Tab eventKey="hotels" title="Hotels">
                                                        <Row className="align-items-end">
                                                          <Col md={6}>
                                                            <Form.Group>
                                                              <Form.Label>City *</Form.Label>
                                                              <Form.Control
                                                                type="text"
                                                                name="city"
                                                                value={hotelItem.city}
                                                                onChange={handleHotelChange}
                                                                placeholder="Enter city name"
                                                              />
                                                            </Form.Group>
                                                          </Col>
                                        
                                                           <Col md={6}>
                                                            <Form.Group>
                                                              <Form.Label>Nights</Form.Label>
                                                              <Form.Control
                                                                type="number"
                                                                name="nights"
                                                                value={hotelItem.nights}
                                                                onChange={handleHotelChange}
                                                              />
                                                            </Form.Group>
                                                          </Col>
                                         
                                                           <Col md={4}>
                                                            <Form.Group className="mt-3">
                                                              <Form.Label>Standard Hotel Name</Form.Label>
                                                              <Form.Control
                                                                type="text"
                                                                name="standard_hotel_name"
                                                                value={hotelItem.standard_hotel_name}
                                                                onChange={handleHotelChange}
                                                                placeholder="Enter standard hotel name"
                                                              />
                                                            </Form.Group>
                                                          </Col>
                                        
                                                           <Col md={4}>
                                                            <Form.Group className="mt-3">
                                                              <Form.Label>Deluxe Hotel Name</Form.Label>
                                                              <Form.Control
                                                                type="text"
                                                                name="deluxe_hotel_name"
                                                                value={hotelItem.deluxe_hotel_name}
                                                                onChange={handleHotelChange}
                                                                 placeholder="Enter deluxe hotel name"
                                                              />
                                                            </Form.Group>
                                                          </Col>
                                        
                                                           <Col md={4}>
                                                            <Form.Group className="mt-3">
                                                              <Form.Label>Executive Hotel Name</Form.Label>
                                                              <Form.Control
                                                                type="text"
                                                                name="executive_hotel_name"
                                                                value={hotelItem.executive_hotel_name}
                                                                onChange={handleHotelChange}
                                                                 placeholder="Enter executive hotel name"
                                                              />
                                                            </Form.Group>
                                                          </Col>
                                        
                                                        </Row>
                                        
                                                        <Form.Group className="mt-3">
                                                          <Form.Label>Hotel Remarks</Form.Label>
                                                          <Form.Control
                                                            as="textarea"
                                                            rows={3}
                                                            name="hotel_remarks"
                                                            value={formData.hotel_remarks}
                                                            onChange={handleBasicChange}
                                                          />
                                                        </Form.Group>
                                        
                                                        {hotelRows.length > 0 && (
                                                          <Table striped bordered hover size="sm" className="mt-3">
                                                            <thead>
                                                              <tr>
                                                                <th>#</th>
                                                                <th>City</th>
                                                                 <th>Nights</th>
                                                                  <th>Standard Hotel</th>
                                                                   <th>Deluxe Hotel</th>
                                                                    <th>Executive Hotel</th>
                                                                   {/* <th>Remarks</th> */}
                                                                <th>Action</th>
                                                              </tr>
                                                            </thead>
                                                            <tbody>
                                                              {hotelRows.map((h, idx) => (
                                                                <tr key={idx}>
                                                                  <td>{idx + 1}</td>
                                                                  <td>{h.city}</td>
                                                                  <td>{h.nights}</td>
                                                                  <td>{h.standard_hotel_name || '-'}</td>
                                                                  <td>{h.deluxe_hotel_name || '-'}</td>
                                                                  <td>{h.executive_hotel_name || '-'}</td>
                                                                  {/* <td>{h.remarks || '-'}</td> */}
                                                                  <td>
                                                                    <div className="d-flex gap-1">
                                                                      <Button
                                                                        variant="outline-warning"
                                                                        size="sm"
                                                                        onClick={() => editHotelRow(idx)}
                                                                        title="Edit"
                                                                      >
                                                                        <Pencil size={14} />
                                                                      </Button>
                                                                      <Button
                                                                        variant="outline-danger"
                                                                        size="sm"
                                                                        onClick={() => removeHotelRow(idx)}
                                                                        title="Remove"
                                                                      >
                                                                        <Trash size={14} />
                                                                      </Button>
                                                                    </div>
                                                                  </td>
                                                                </tr>
                                                              ))}
                                                            </tbody>
                                                          </Table>
                                                        )}
                            </Tab>


                 <Tab eventKey="visa" title="Visa">
                              <Tabs
                                activeKey={activeVisaSubTab}
                                onSelect={(k) => setActiveVisaSubTab(k)}
                                className="mb-4"
                              >
                                {/* Subtab 1: Tourist Visa */}
                                <Tab eventKey="tourist" title="Tourist Visa">
                                  <Form.Group className="mb-3">
                                    <Form.Label>Tourist Visa</Form.Label>
                                    <Form.Control
                                      as="textarea"
                                      rows={4}
                                      name="description"
                                      value={touristVisaForm.description}
                                      onChange={handleTouristVisaChange}
                                      placeholder="Enter tourist visa details"
                                    />
                                  </Form.Group>
              
                                  {touristVisaItems.length > 0 && (
                                    <Table striped bordered hover size="sm" className="mt-3">
                                      <thead>
                                        <tr>
                                          <th>#</th>
                                          <th>Description</th>
                                          <th>Action</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {touristVisaItems.map((item, idx) => (
                                          <tr key={idx}>
                                            <td>{idx + 1}</td>
                                            <td>{item.description || '-'}</td>
                                            <td>
                                              <div className="d-flex gap-1">
                                                <Button
                                                  variant="outline-warning"
                                                  size="sm"
                                                  onClick={() => editTouristVisa(idx)}
                                                  title="Edit"
                                                >
                                                  <Pencil size={14} />
                                                </Button>
                                                <Button
                                                  variant="outline-danger"
                                                  size="sm"
                                                  onClick={() => removeTouristVisa(idx)}
                                                  title="Remove"
                                                >
                                                  <Trash size={14} />
                                                </Button>
                                              </div>
                                            </td>
                                          </tr>
                                        ))}
                                      </tbody>
                                    </Table>
                                  )}
                                </Tab>
              
                                {/* Subtab 2: Transit Visa */}
                                <Tab eventKey="transit" title="Transit Visa">
                                  <Form.Group className="mb-3">
                                    <Form.Label>Transit Visa </Form.Label>
                                    <Form.Control
                                      as="textarea"
                                      rows={4}
                                      name="description"
                                      value={transitVisaForm.description}
                                      onChange={handleTransitVisaChange}
                                      placeholder="Enter transit visa details"
                                    />
                                  </Form.Group>
              
                                  {transitVisaItems.length > 0 && (
                                    <Table striped bordered hover size="sm" className="mt-3">
                                      <thead>
                                        <tr>
                                          <th>#</th>
                                          <th>Description</th>
                                          <th>Action</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {transitVisaItems.map((item, idx) => (
                                          <tr key={idx}>
                                            <td>{idx + 1}</td>
                                            <td>{item.description || '-'}</td>
                                            <td>
                                              <div className="d-flex gap-1">
                                                <Button
                                                  variant="outline-warning"
                                                  size="sm"
                                                  onClick={() => editTransitVisa(idx)}
                                                  title="Edit"
                                                >
                                                  <Pencil size={14} />
                                                </Button>
                                                <Button
                                                  variant="outline-danger"
                                                  size="sm"
                                                  onClick={() => removeTransitVisa(idx)}
                                                  title="Remove"
                                                >
                                                  <Trash size={14} />
                                                </Button>
                                              </div>
                                            </td>
                                          </tr>
                                        ))}
                                      </tbody>
                                    </Table>
                                  )}
                                </Tab>
              
                                {/* Subtab 3: Business Visa */}
                                <Tab eventKey="business" title="Business Visa">
                                  <Form.Group className="mb-3">
                                    <Form.Label>Business Visa</Form.Label>
                                    <Form.Control
                                      as="textarea"
                                      rows={4}
                                      name="description"
                                      value={businessVisaForm.description}
                                      onChange={handleBusinessVisaChange}
                                      placeholder="Enter business visa details"
                                    />
                                  </Form.Group>
              
                                  {businessVisaItems.length > 0 && (
                                    <Table striped bordered hover size="sm" className="mt-3">
                                      <thead>
                                        <tr>
                                          <th>#</th>
                                          <th>Description</th>
                                          <th>Action</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {businessVisaItems.map((item, idx) => (
                                          <tr key={idx}>
                                            <td>{idx + 1}</td>
                                            <td>{item.description || '-'}</td>
                                            <td>
                                              <div className="d-flex gap-1">
                                                <Button
                                                  variant="outline-warning"
                                                  size="sm"
                                                  onClick={() => editBusinessVisa(idx)}
                                                  title="Edit"
                                                >
                                                  <Pencil size={14} />
                                                </Button>
                                                <Button
                                                  variant="outline-danger"
                                                  size="sm"
                                                  onClick={() => removeBusinessVisa(idx)}
                                                  title="Remove"
                                                >
                                                  <Trash size={14} />
                                                </Button>
                                              </div>
                                            </td>
                                          </tr>
                                        ))}
                                      </tbody>
                                    </Table>
                                  )}
                                </Tab>
              
                                {/* Subtab 4: Visa Form */}
<Tab eventKey="form" title="Visa Form">
  {/* Add New Visa Form Button */}
  <div className="mb-3">
    <Button 
      variant="outline-primary" 
      size="sm" 
      onClick={() => {
        const newVisaForm = {
          type: 'New Visa Type',
          download_action: 'Download',
          fill_action: 'Fill Manually',
          action1_file: null,
          action2_file: null
        };
        setVisaFormItems([...visaFormItems, newVisaForm]);
      }}
    >
      + Add New Visa Form
    </Button>
  </div>

  {/* Visa Forms Table */}
  {visaFormItems.length === 0 ? (
    <div className="text-center py-4">
      <p className="text-muted">No visa forms added yet. Click "Add New Visa Form" to get started.</p>
    </div>
  ) : (
    <Table striped bordered hover size="sm">
      <thead>
        <tr>
          <th width="20%">Visa Type</th>
          <th width="35%">Upload PDF</th>
          <th width="35%">Upload Word</th>
          <th width="10%">Actions</th>
        </tr>
      </thead>
      <tbody>
        {visaFormItems.map((item, idx) => {
          const pdfFile = item.action1_file;
          const wordFile = item.action2_file;
          const pdfUrl = getFileUrl(pdfFile);
          const wordUrl = getFileUrl(wordFile);
          
          return (
            <tr key={idx}>
              <td>
                <Form.Control
                  type="text"
                  value={item.type}
                  onChange={(e) => {
                    const updated = [...visaFormItems];
                    updated[idx].type = e.target.value;
                    setVisaFormItems(updated);
                  }}
                  placeholder="Enter visa type"
                  size="sm"
                />
              </td>
              <td>
                <div className="d-flex flex-column gap-2">
                  {/* Upload Button */}
                  <div>
                    <Button 
                      variant="outline-primary" 
                      size="sm"
                      onClick={() => document.getElementById(`pdf-upload-${idx}`).click()}
                    >
                      {pdfFile ? 'Change PDF' : 'Upload PDF'}
                    </Button>
                    <Form.Control
                      type="file"
                      id={`pdf-upload-${idx}`}
                      accept=".pdf"
                      className="d-none"
                      onChange={(e) => handleVisaFormFileChange(idx, 'action1', e.target.files[0])}
                    />
                  </div>
                  
                  {/* File Info and View Button */}
                  {pdfFile && (
                    <div className="d-flex align-items-center justify-content-between bg-light p-2 rounded">
                      <div className="flex-grow-1">
                        <small className="text-success d-block">
                          <strong>✓ Uploaded:</strong>
                        </small>
                        <small className="text-muted d-block">
                          {typeof pdfFile === 'string' ? pdfFile : pdfFile.name}
                        </small>
                      </div>
                      
                      {pdfUrl && (
                        <div className="ms-2">
                          <Button
                            variant="outline-info"
                            size="sm"
                            onClick={() => openFileInNewTab(pdfUrl)}
                            title="View PDF"
                            className="d-flex align-items-center"
                          >
                            👁️ View
                          </Button>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </td>
              
              <td>
                <div className="d-flex flex-column gap-2">
                  {/* Upload Button */}
                  <div>
                    <Button 
                      variant="outline-secondary" 
                      size="sm"
                      onClick={() => document.getElementById(`word-upload-${idx}`).click()}
                    >
                      {wordFile ? 'Change Word' : 'Upload Word'}
                    </Button>
                    <Form.Control
                      type="file"
                      id={`word-upload-${idx}`}
                      accept=".doc,.docx"
                      className="d-none"
                      onChange={(e) => handleVisaFormFileChange(idx, 'action2', e.target.files[0])}
                    />
                  </div>
                  
                  {/* File Info and View Button */}
                  {wordFile && (
                    <div className="d-flex align-items-center justify-content-between bg-light p-2 rounded">
                      <div className="flex-grow-1">
                        <small className="text-success d-block">
                          <strong>✓ Uploaded:</strong>
                        </small>
                        <small className="text-muted d-block">
                          {typeof wordFile === 'string' ? wordFile : wordFile.name}
                        </small>
                      </div>
                      
                      {wordUrl && (
                        <div className="ms-2">
                          <Button
                            variant="outline-info"
                            size="sm"
                            onClick={() => openFileInNewTab(wordUrl)}
                            title="View Document"
                            className="d-flex align-items-center"
                          >
                            👁️ View
                          </Button>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </td>
              <td>
                <div className="d-flex flex-column gap-1">
                  <Button
                    variant="outline-danger"
                    size="sm"
                    onClick={() => {
                      const newItems = [...visaFormItems];
                      newItems.splice(idx, 1);
                      setVisaFormItems(newItems);
                    }}
                    title="Remove"
                  >
                    <Trash size={14} />
                  </Button>
                </div>
              </td>
            </tr>
          );
        })}
      </tbody>
    </Table>
  )}

  {/* Remarks Section */}
  <Card className="mt-3">
    <Card.Body>
      <Form.Group>
        <Form.Label>Tourist Visa Remarks</Form.Label>
        <Form.Control
          as="textarea"
          rows={4}
          value={touristVisaRemarks}
          onChange={handleTouristVisaRemarksChange}
          placeholder="Enter remarks about visa forms..."
        />
      </Form.Group>
    </Card.Body>
  </Card>
</Tab>
              
              
                                {/* Subtab 5: Photo */}
                               {/* Subtab 5: Photo */}
                            {/* Subtab 5: Photo */}
<Tab eventKey="photo" title="Photo">
  {/* Add/Edit Photo Form */}
  <Card className="mb-4">
    <Card.Body>
      <Form.Group className="mb-3">
        <Form.Label>
          {editingType === 'photo' ? 'Edit Photo Description' : 'Add Photo Description'}
          {editingType === 'photo' && (
            <span className="badge bg-warning text-dark ms-2">
              Editing item #{editIndex + 1}
            </span>
          )}
        </Form.Label>
        <div className="d-flex gap-2">
          <Form.Control
            as="textarea"
            rows={2}
            name="description"
            value={photoForm.description}
            onChange={handlePhotoChange}
            placeholder="Type photo requirement description"
          />
          {/* <Button 
            variant={editingType === 'photo' ? "warning" : "success"} 
            onClick={addPhoto}
            className="align-self-start"
            disabled={!photoForm.description.trim()}
          >
            {editingType === 'photo' ? 'Update Photo' : '+ Add Photo'}
          </Button> */}
        </div>
      </Form.Group>
    </Card.Body>
  </Card>

  {/* Existing Photo Items Table */}
  {photoItems.length > 0 && (
    <Card>
      <Card.Body>
        <Table striped bordered hover size="sm">
          <thead>
            <tr>
              <th>#</th>
              <th>Description</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {photoItems.map((item, idx) => (
              <tr key={idx} className={editingType === 'photo' && editIndex === idx ? 'table-warning' : ''}>
                <td>{idx + 1}</td>
                <td>{item.description || '-'}</td>
                <td>
                  <div className="d-flex gap-1">
                    <Button
                      variant={editingType === 'photo' && editIndex === idx ? "warning" : "outline-warning"}
                      size="sm"
                      onClick={() => editPhoto(idx)}
                      title="Edit"
                    >
                      <Pencil size={14} />
                    </Button>
                    <Button
                      variant="outline-danger"
                      size="sm"
                      onClick={() => removePhoto(idx)}
                      title="Remove"
                    >
                      <Trash size={14} />
                    </Button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Card.Body>
    </Card>
  )}
</Tab>

              
                                {/* Subtab 6: Visa Fees */}
                                {/* Subtab 6: Visa Fees */}
                            <Tab eventKey="fees" title="Visa Fees">
                              <div className="mb-3">
                                <Button 
                                  variant="outline-success" 
                                  size="sm" 
                                  onClick={addVisaFeesRow}
                                >
                                  + Add New Visa Fees
                                </Button>
                              </div>
                              
                              <Table striped bordered hover size="sm">
                                <thead>
                                  <tr>
                                    {/* <th>Tabs</th> */}
                                    <th>Tourist Visa</th>
                                    <th>Toursit Visa Charges</th>
                                    <th>Transit Visa</th>
                                    <th>Transit Visa Charges</th>
                                    <th>Business Visa</th>
                                    <th>Business Visa Charges</th>
                                    <th>Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {/* Render all rows including free flow entries */}
                                  {visaFeesRows.map((row) => (
                                    <tr key={row.id}>
                                      <td>
                                        <Form.Control
                                          type="text"
                                          value={row.tourist}
                                          onChange={(e) => handleVisaFeesChange(row.id, 'tourist', e.target.value)}
                                          placeholder="Free flow entry"
                                          size="sm"
                                        />
                                      </td>
                                      <td>
                                        <Form.Control
                                          type="text"
                                          value={row.tourist_charges}
                                          onChange={(e) => handleVisaFeesChange(row.id, 'tourist_charges', e.target.value)}
                                          placeholder="Charges for Tourist"
                                          size="sm"
                                        />
                                      </td>
                                      <td>
                                        <Form.Control
                                          type="text"
                                          value={row.transit}
                                          onChange={(e) => handleVisaFeesChange(row.id, 'transit', e.target.value)}
                                          placeholder="Free flow entry"
                                          size="sm"
                                        />
                                      </td>
                                      <td>
                                        <Form.Control
                                          type="text"
                                          value={row.transit_charges}
                                          onChange={(e) => handleVisaFeesChange(row.id, 'transit_charges', e.target.value)}
                                          placeholder="Charges for Transit"
                                          size="sm"
                                        />
                                      </td>
                                      <td>
                                        <Form.Control
                                          type="text"
                                          value={row.business}
                                          onChange={(e) => handleVisaFeesChange(row.id, 'business', e.target.value)}
                                          placeholder="Free flow entry"
                                          size="sm"
                                        />
                                      </td>
                                      <td>
                                        <Form.Control
                                          type="text"
                                          value={row.business_charges}
                                          onChange={(e) => handleVisaFeesChange(row.id, 'business_charges', e.target.value)}
                                          placeholder="Charges for Business"
                                          size="sm"
                                        />
                                      </td>
                                      <td>
                                        <Button
                                          variant="outline-danger"
                                          size="sm"
                                          onClick={() => removeVisaFeesRow(row.id)}
                                          title="Remove"
                                          disabled={row.id <= 3} // Prevent removing first 3 rows
                                        >
                                          <Trash size={14} />
                                        </Button>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </Table>
                            </Tab>
              
              
              
              
                                {/* Subtab 7: Submission & Pick Up */}
                                  <Tab eventKey="submission" title="Submission & Pick Up">
                                    <div className="mb-3">
                                      <Button 
                                        variant="outline-success" 
                                        size="sm" 
                                        onClick={addSubmissionRow}
                                      >
                                        + Add New Submission & Pick Up
                                      </Button>
                                    </div>
                                    
                                    <Table striped bordered hover size="sm">
                                      <thead>
                                        <tr>
                                          <th width="25%">Item</th>
                                          <th width="25%">Tourist Visa</th>
                                          <th width="25%">Transit Visa</th>
                                          <th width="25%">Business Visa</th>
                                          <th width="5%">Action</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        
                                        {/* Dynamic rows */}
                                        {submissionRows.map((row) => (
                                          <tr key={row.id}>
                                            <td>
                                              <Form.Control
                                                type="text"
                                                value={row.label}
                                                onChange={(e) => handleSubmissionLabelChange(row.id, e.target.value)}
                                                placeholder="Enter item label"
                                                size="sm"
                                              />
                                            </td>
                                            <td>
                                              <Form.Control
                                                type="text"
                                                value={row.tourist}
                                                onChange={(e) => handleSubmissionValueChange(row.id, 'tourist', e.target.value)}
                                                placeholder="Free flow alphanumeric"
                                                size="sm"
                                              />
                                            </td>
                                            <td>
                                              <Form.Control
                                                type="text"
                                                value={row.transit}
                                                onChange={(e) => handleSubmissionValueChange(row.id, 'transit', e.target.value)}
                                                placeholder="Free flow alphanumeric"
                                                size="sm"
                                              />
                                            </td>
                                            <td>
                                              <Form.Control
                                                type="text"
                                                value={row.business}
                                                onChange={(e) => handleSubmissionValueChange(row.id, 'business', e.target.value)}
                                                placeholder="Free flow alphanumeric"
                                                size="sm"
                                              />
                                            </td>
                                            <td>
                                              <Button
                                                variant="outline-danger"
                                                size="sm"
                                                onClick={() => removeSubmissionRow(row.id)}
                                                title="Remove"
                                              >
                                                <Trash size={14} />
                                              </Button>
                                            </td>
                                          </tr>
                                        ))}
                                      </tbody>
                                    </Table>
                                  </Tab>
              
              
                              </Tabs>
                            </Tab>



                                 <Tab eventKey="bookingPoi" title="Booking POI">
                      <Form.Group className="mb-3">
                        <Row>
                          <Col md={8}>
                            <Form.Label>Booking Policy</Form.Label>
                            <Form.Control
                              as="textarea"
                              rows={4}
                              value={poiText}
                              onChange={(e) => setPoiText(e.target.value)}
                              placeholder="Type booking policy here"
                            />
                          </Col>
                    
                          <Col md={4}>
                            <Form.Label>Amount Details</Form.Label>
                            <Form.Control
                              type="text"
                              value={poiAmount}
                              onChange={(e) => setPoiAmount(e.target.value)}
                              placeholder="Enter amount details"
                            />
                          </Col>
                        </Row>
                    
                        <Form.Group className="mt-3">
                          <Form.Label>Booking Policy Remarks</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={3}
                            name="booking_poi_remarks"
                            value={formData.booking_poi_remarks}
                            onChange={handleBasicChange}
                          />
                        </Form.Group>
                      </Form.Group>
                    
                      {bookingPois.length > 0 && (
                        <Table striped bordered hover size="sm">
                          <thead>
                            <tr>
                              <th>#</th>
                              <th>Item</th>
                              <th>Amount Details</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {bookingPois.map((p, idx) => (
                              <tr key={idx}>
                                <td>{idx + 1}</td>
                                <td style={{ whiteSpace: 'pre-line' }}>{p.item}</td>
                                <td>{p.amount_details}</td>
                                <td>
                                  <div className="d-flex gap-1">
                                    <Button
                                      variant="outline-warning"
                                      size="sm"
                                      onClick={() => editPoi(idx)}
                                      title="Edit"
                                    >
                                      <Pencil size={14} />
                                    </Button>
                                    <Button
                                      variant="outline-danger"
                                      size="sm"
                                      onClick={() => removePoi(idx)}
                                      title="Remove"
                                    >
                                      <Trash size={14} />
                                    </Button>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      )}
                    </Tab>
                    
                                <Tab eventKey="cancellation" title="Cancellation Policy">
                      <Row>
                        <Col md={8}>
                          <Form.Label>Cancellation Policy</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={4}
                            name="cancellation_policy"
                            value={cancelItem.cancellation_policy}
                            onChange={handleCancelChange}
                            placeholder="Type cancellation policy here"
                            style={{ whiteSpace: 'pre-line' }}
                          />
                        </Col>
                    
                        <Col md={4}>
                          <Form.Label>Charges</Form.Label>
                          <Form.Control
                            type="text"
                            name="charges"
                            value={cancelItem.charges}
                            onChange={handleCancelChange}
                            placeholder="Example: No refund / 50% retained"
                          />
                        </Col>
                      </Row>
                    
                      <Form.Group className="mt-3">
                        <Form.Label>Cancellation Remarks</Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={3}
                          name="cancellation_remarks"
                          value={formData.cancellation_remarks}
                          onChange={handleBasicChange}
                        />
                      </Form.Group>
                    
                      {cancelPolicies.length > 0 && (
                        <Table striped bordered hover className="mt-3" size="sm">
                          <thead>
                            <tr>
                              <th>#</th>
                              <th>Cancellation Policy</th>
                              <th>Charges</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {cancelPolicies.map((c, idx) => (
                              <tr key={idx}>
                                <td>{idx + 1}</td>
                                <td style={{ whiteSpace: 'pre-line', maxWidth: '400px' }}>
                                  <div style={{ maxHeight: '100px', overflowY: 'auto' }}>
                                    {c.cancellation_policy}
                                  </div>
                                </td>
                                <td>{c.charges || "-"}</td>
                                <td>
                                  <div className="d-flex gap-1">
                                    <Button
                                      variant="outline-warning"
                                      size="sm"
                                      onClick={() => editCancelRow(idx)}
                                      title="Edit"
                                    >
                                      <Pencil size={14} />
                                    </Button>
                                    <Button
                                      variant="outline-danger"
                                      size="sm"
                                      onClick={() => removeCancelRow(idx)}
                                      title="Remove"
                                    >
                                      <Trash size={14} />
                                    </Button>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      )}
                    </Tab>

              <Tab eventKey="instructions" title="Instructions">
                {/* Instruction Remarks (NEW - same as Group tour, prefilled) */}
                <Form.Group className="mb-3">
                  <Form.Label>Instruction Remarks</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={6}
                    name="instruction_remarks"
                    value={formData.instruction_remarks || ''}
                    onChange={handleBasicChange}
                    placeholder="Enter general instructions for travelers here..."
                  />
                </Form.Group>

                {/* <Form.Group className="mb-3">
                  <Form.Label>Instruction</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    value={instructionText}
                    onChange={(e) => setInstructionText(e.target.value)}
                    placeholder="Type instruction"
                  />
                </Form.Group> */}

                {instructions.length > 0 && (
                  <Table striped bordered hover size="sm">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Instruction</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {instructions.map((item, idx) => (
                        <tr key={idx}>
                          <td>{idx + 1}</td>
                          <td>{item}</td>
                          <td>
                            <div className="d-flex gap-1">
                              <Button
                                variant="outline-warning"
                                size="sm"
                                onClick={() => editInstruction(idx)}
                                title="Edit"
                              >
                                <Pencil size={14} />
                              </Button>
                              <Button
                                variant="outline-danger"
                                size="sm"
                                onClick={() => removeInstruction(idx)}
                                title="Remove"
                              >
                                <Trash size={14} />
                              </Button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                )}
              </Tab>

                 <Tab eventKey="images" title="Images">
                   {/* Section for adding NEW images */}
                   <Card className="mb-4">
                     <Card.Header>Add New Images</Card.Header>
                     <Card.Body>
                       <Form.Group className="mb-3">
                         <Form.Label>Upload New Images</Form.Label>
                         <Form.Control
                           type="file"
                           multiple
                           onChange={handleImageChange}
                           accept="image/jpeg,image/jpg,image/png,image/webp"
                         />
                         <Form.Text className="text-muted">
                           You can select multiple images (JPEG, PNG, WebP). Max 5MB per image.
                         </Form.Text>
                       </Form.Group>
                       
                       <Form.Group className="mb-3">
                         <Form.Label>Caption (optional - applies to all new images)</Form.Label>
                         <Form.Control
                           type="text"
                           value={imageCaption}
                           onChange={(e) => setImageCaption(e.target.value)}
                           placeholder="Enter a caption for the new images"
                         />
                       </Form.Group>
                       
                       {imagePreviews.length > 0 && (
                         <div className="mt-3">
                           <p className="mb-2">
                             <strong>{imagePreviews.length} new image(s) ready to upload:</strong>
                           </p>
                           <Row>
                             {imageFiles.map((file, idx) => (
                               <Col md={3} key={idx} className="mb-3">
                                 <div className="position-relative">
                                   <img
                                     src={imagePreviews[idx]}
                                     alt={`new-${idx}`}
                                     style={{
                                       width: '100%',
                                       height: '150px',
                                       objectFit: 'cover',
                                       borderRadius: '8px'
                                     }}
                                   />
                                   <div className="position-absolute top-0 end-0 bg-dark bg-opacity-50 text-white p-1 rounded">
                                     {file.name}
                                   </div>
                                 </div>
                               </Col>
                             ))}
                           </Row>
                         </div>
                       )}
                     </Card.Body>
                   </Card>
               
                   {/* Section for EXISTING images with edit/delete */}
                   <Card>
                     <Card.Header>Existing Images</Card.Header>
                     <Card.Body>
                       {existingImages.length === 0 ? (
                         <div className="text-center py-4">
                           <p className="text-muted">No images uploaded yet.</p>
                         </div>
                       ) : (
                         <Row>
                           {existingImages.map((image) => (
                             <Col md={4} lg={3} key={image.image_id} className="mb-4">
                               <Card className="h-100">
                                 <Card.Body className="p-2">
                                   <div className="position-relative">
                                     <img
                                       src={image.url}
                                       alt={`tour-image-${image.image_id}`}
                                       style={{
                                         width: '100%',
                                         height: '150px',
                                         objectFit: 'cover',
                                         borderRadius: '6px'
                                       }}
                                       className="mb-2"
                                     />
                                     
                                     {image.is_cover === 1 && (
                                       <div className="position-absolute top-0 start-0 bg-warning text-dark px-2 py-1 rounded-end">
                                         <strong>★ Cover</strong>
                                       </div>
                                     )}
                                     
                                     {editingImageId === image.image_id ? (
                                       <div className="mt-3 border p-3 rounded">
                                         <Form.Group>
                                           <Form.Label>Replace with new image:</Form.Label>
                                           <Form.Control
                                             id="replacementFileInput"
                                             type="file"
                                             onChange={handleReplacementFileChange}
                                             accept="image/jpeg,image/jpg,image/png,image/webp"
                                           />
                                         </Form.Group>
                                         
                                         {replacementPreview && (
                                           <div className="mt-2">
                                             <p><strong>New preview:</strong></p>
                                             <img
                                               src={replacementPreview}
                                               alt="replacement"
                                               style={{
                                                 width: '100%',
                                                 height: '100px',
                                                 objectFit: 'cover',
                                                 borderRadius: '4px'
                                               }}
                                             />
                                           </div>
                                         )}
                                         
                                         <div className="d-flex gap-2 mt-3">
                                           <Button
                                             variant="success"
                                             size="sm"
                                             onClick={() => updateImage(image.image_id)}
                                             disabled={!replacementFile || loading}
                                           >
                                             {loading ? 'Updating...' : 'Update'}
                                           </Button>
                                           <Button
                                             variant="outline-secondary"
                                             size="sm"
                                             onClick={cancelEditImage}
                                             disabled={loading}
                                           >
                                             Cancel
                                           </Button>
                                         </div>
                                       </div>
                                     ) : (
                                       <div className="mt-2">
                                         <div className="d-flex flex-wrap gap-1 justify-content-center">
                                           {/* Set as Cover Button */}
                                           {image.is_cover === 0 && (
                                             <Button
                                               variant="outline-warning"
                                               size="sm"
                                               onClick={() => setCoverImage(image.image_id)}
                                               title="Set as Cover"
                                               disabled={loading}
                                             >
                                               ★ Set Cover
                                             </Button>
                                           )}
                                           
                                           {/* Edit Button */}
                                           <Button
                                             variant="outline-primary"
                                             size="sm"
                                             onClick={() => startEditImage(image)}
                                             title="Replace Image"
                                             disabled={loading}
                                           >
                                             <Pencil size={14} /> Replace
                                           </Button>
                                           
                                           {/* Delete Button */}
                                           <Button
                                             variant="outline-danger"
                                             size="sm"
                                             onClick={() => deleteImage(image.image_id)}
                                             title="Delete Image"
                                             disabled={loading}
                                           >
                                             <Trash size={14} />
                                           </Button>
                                         </div>
                                       </div>
                                     )}
                                   </div>
                                 </Card.Body>
                                 <Card.Footer className="bg-transparent border-0 pt-0">
                                   <small className="text-muted">
                                     {image.caption ? `Caption: ${image.caption}` : 'No caption'}
                                   </small>
                                 </Card.Footer>
                               </Card>
                             </Col>
                           ))}
                         </Row>
                       )}
                       
                       {/* Show existing image count */}
                       {existingImages.length > 0 && (
                         <div className="mt-3 text-center">
                           <p className="text-muted">
                             Total images: {existingImages.length} | 
                             Cover image: {existingImages.find(img => img.is_cover === 1) ? 'Set' : 'Not set'}
                           </p>
                         </div>
                       )}
                     </Card.Body>
                   </Card>
                </Tab>
            </Tabs>
          </Card.Body>
        </Card>
      </Container>
    </Navbar>
  );
};

export default AddSeniorTour;